{
  "PDF preview": "Просмотр PDF",
  "Zoom out": "Уменьшить",
  "Zoom in": "Увеличить",
  "Fit width": "По ширине",
  "Choose valid collection columns without duplicates.": "Выберите допустимые столбцы списка без повторений.",
  "Settings": "Настройки",
  "Main menu": "Главное меню",
  "!CFG": "!CFG",
  "!REV": "!REV",
  ", not": ", а не",
  ". Changing construction class requires a different identity.": ". Изменение типа конструкции требует другого идентификатора.",
  ". It is shown only once.": ". Показано только один раз.",
  ". Where-used follows the actual structure—not the numbering path.": ". Использование определяется фактической структурой, а не путём нумерации.",
  "? The history remains.": "? История сохраняется.",
  "? The original part remains in the registry.": "? Исходная деталь остаётся в реестре.",
  "A PIN needs a project/product version and at least one identity node (maximum depth 32).": "PIN должен содержать проект, версию изделия и хотя бы один узел идентичности; глубина — до 32.",
  "A change is awaiting confirmation": "Изменение ожидает подтверждения",
  "A controlled construction-class change requires another identity. Issue the new part rather than renaming this one.": "Для изменения типа контролируемой конструкции создайте другую деталь, а не переименовывайте эту.",
  "A new link will replace the previous invitation link for": "Новая ссылка заменит предыдущее приглашение для",
  "A part cannot replace itself.": "Деталь не может заменять саму себя.",
  "A piece part cannot have a configuration.": "Деталь не может иметь конфигурацию.",
  "A piece part cannot have controlled children.": "Деталь не может содержать контролируемые компоненты.",
  "A piece part cannot retain controlled children.": "Деталь не может сохранять контролируемые компоненты.",
  "A qualified reference must select a released revision.": "Уточнённая ссылка должна указывать выпущенную ревизию.",
  "A verified Google email is required.": "Нужен подтверждённый адрес электронной почты Google.",
  "ALPHA": "ALPHA",
  "About {value0}": "О {value0}",
  "Accept company invitation": "Принять приглашение в компанию",
  "Account": "Учётная запись",
  "Account and company settings": "Настройки учётной записи и компании",
  "Active": "Активен",
  "Active assembly": "Текущая сборка",
  "Add alias": "Добавить внешний номер",
  "Add code": "Добавить код",
  "Add directional replacement": "Добавить направленную замену",
  "Add part": "Добавить деталь",
  "Add replacement": "Добавить замену",
  "Add to {value0}": "Добавить в {value0}",
  "Adding…": "Добавление…",
  "Alias notes": "Примечания к внешнему номеру",
  "Alias organization": "Организация внешнего номера",
  "Alias type": "Тип внешнего номера",
  "All alias types": "Все типы внешних номеров",
  "All companies": "Все компании",
  "All selected child revisions must be released.": "Все выбранные ревизии компонентов должны быть выпущены.",
  "All states": "Все состояния",
  "All types": "Все типы",
  "Aluminium": "Алюминий",
  "An assembly needs at least one controlled child before release.": "Перед выпуском сборка должна содержать хотя бы один контролируемый компонент.",
  "An example drawing change tightens a tolerance.": "В примере изменение чертежа сужает допуск.",
  "An external alias cannot impersonate another canonical part number.": "Внешний номер не может совпадать с каноническим номером другой детали.",
  "An identifier or historical alias already occupies the requested number.": "Запрошенный номер уже занят идентификатором или историческим перенаправлением.",
  "An independently orderable configured product needs its own assembly P/N.": "Конфигурируемое изделие, заказываемое отдельно, требует собственного номера сборки.",
  "An invitation is already pending. Replace its link instead.": "Приглашение уже ожидает ответа. Замените его ссылку.",
  "An occurrence cannot be moved to another owner by editing it.": "Нельзя перенести использование детали к другому владельцу редактированием.",
  "Another change was being saved. Retry this same request.": "Сохранялось другое изменение. Повторите тот же запрос.",
  "Another owner must accept membership before removing the last owner.": "Прежде чем удалить последнего владельца, другой владелец должен принять приглашение.",
  "Another project": "Другой проект",
  "Apply filters": "Применить фильтры",
  "Arm": "Рука",
  "Arm assembly": "Сборка руки",
  "As authored": "Как задано",
  "Ask a company owner to register a new code.": "Попросите владельца компании зарегистрировать новый код.",
  "Assembly": "Сборка",
  "Assembly configurations": "Конфигурации сборки",
  "Assignment correction": "Исправление назначения",
  "Back to blueprint": "К чертежу",
  "Before controlled dependencies exist, correct the assignment with an audit entry. No old-number redirect is kept.": "До появления контролируемых зависимостей назначение можно исправить с записью в аудите. Старый номер не перенаправляется.",
  "Best match": "Лучшее совпадение",
  "Bonded": "Клеёное",
  "Bonded assembly": "Клеёная сборка",
  "Bonded grip": "Клеёный захват",
  "Both leaders point to the same P/N.": "Обе выноски указывают на один и тот же номер.",
  "CF": "CF",
  "Cancel": "Отмена",
  "Cancel {value0} edit": "Отменить редактирование {value0}",
  "Carbon fibre": "Углепластик",
  "Change {value0}'s role": "Изменить роль {value0}",
  "Check result": "Проверить результат",
  "Choose Active, Obsolete or Retired.": "Выберите: активная, устаревшая или выведенная из использования.",
  "Choose Owner, Editor or Viewer.": "Выберите владельца, редактора или читателя.",
  "Choose P, A, W, G or R.": "Выберите P, A, W, G или R.",
  "Choose a company": "Выберите компанию",
  "Choose a measurement unit preference.": "Выберите систему единиц измерения.",
  "Choose a part and exact revision from this company.": "Выберите деталь и точную ревизию из этой компании.",
  "Choose a product version from the default project.": "Выберите версию изделия из проекта по умолчанию.",
  "Choose a standard position or register its code in this company.": "Выберите стандартное положение или зарегистрируйте код в этой компании.",
  "Choose a supplier, manufacturer or customer alias.": "Выберите внешний номер поставщика, производителя или заказчика.",
  "Choose a supported interface language.": "Выберите поддерживаемый язык интерфейса.",
  "Choose a supported regional format.": "Выберите поддерживаемый региональный формат.",
  "Choose a table density.": "Выберите плотность таблицы.",
  "Choose a valid alias type.": "Выберите корректный тип внешнего номера.",
  "Choose a valid part state.": "Выберите корректное состояние детали.",
  "Choose a valid part type.": "Выберите корректный тип детали.",
  "Choose a valid results page and page size.": "Выберите корректную страницу результатов и её размер.",
  "Choose a valid search order.": "Выберите корректный порядок поиска.",
  "Choose a valid time zone.": "Выберите корректный часовой пояс.",
  "Choose an assembly parent in the selected product version.": "Выберите родительскую сборку в этой версии изделия.",
  "Choose an assembly parent outside this identity's descendant graph, in the selected product version.": "Выберите родительскую сборку в этой версии изделия вне дерева потомков этой детали.",
  "Choose an editable assembly and an exact part revision.": "Выберите доступную для редактирования сборку и точную ревизию детали.",
  "Choose each time": "Выбирать каждый раз",
  "Choose exactly one structure owner.": "Выберите ровно одного владельца структуры.",
  "Choose its revision and quantity to add it to this assembly.": "Выберите ревизию и количество для добавления в эту сборку.",
  "Choose one structure owner.": "Выберите одного владельца структуры.",
  "Choose the default company first.": "Сначала выберите компанию по умолчанию.",
  "Choose the part that can replace this one.": "Выберите деталь, которая может заменить эту.",
  "Class": "Класс",
  "Clear filters": "Очистить фильтры",
  "Close": "Закрыть",
  "Close reuse parts": "Закрыть повторное использование деталей",
  "Close {value0}": "Закрыть {value0}",
  "Code": "Код",
  "Comfortable": "Комфортная",
  "Compact": "Компактная",
  "Companies": "Компании",
  "Company": "Компания",
  "Company code": "Код компании",
  "Company name": "Название компании",
  "Company not found.": "Компания не найдена.",
  "Company parts": "Детали компании",
  "Company settings": "Настройки компании",
  "Company-wide role": "Роль в компании",
  "Configuration": "Конфигурация",
  "Configuration name": "Название конфигурации",
  "Configurations": "Конфигурации",
  "Configurations apply to assemblies, not piece parts.": "Конфигурации применяются к сборкам, а не к деталям.",
  "Construction classes": "Типы конструкции",
  "Copy a revision of this part.": "Скопировать ревизию этой детали.",
  "Correct engineering identity": "Исправить инженерную идентичность",
  "Corrected text": "Исправленный текст",
  "Correction & replacement": "Исправление и замена",
  "Correction reason": "Причина исправления",
  "Cover": "Крышка",
  "Cover numbered beneath it": "Крышка с номером под этой сборкой",
  "Cover revisions": "Ревизии крышки",
  "Cover · 1 each · forearm": "Крышка · 1 шт. · предплечье",
  "Create company": "Создать компанию",
  "Create configuration": "Создать конфигурацию",
  "Create invitation": "Создать приглашение",
  "Create project": "Создать проект",
  "Create variant": "Создать вариант",
  "Create version": "Создать версию",
  "Current structure": "Текущая структура",
  "Default quantity unit": "Единица количества по умолчанию",
  "Default workspace": "Рабочее пространство по умолчанию",
  "Description": "Описание",
  "Details": "Сведения",
  "Different identity": "Другая идентичность",
  "Directional replacements": "Направленные замены",
  "Draft": "Черновик",
  "Drawing unavailable. Part-number examples remain interactive.": "Чертёж недоступен. Примеры номеров остаются интерактивными.",
  "ER": "ER",
  "Edit company": "Редактировать компанию",
  "Edit configuration": "Редактировать конфигурацию",
  "Edit details": "Редактировать сведения",
  "Edit part details": "Редактировать сведения детали",
  "Edit part use": "Редактировать использование детали",
  "Edit product version": "Редактировать версию изделия",
  "Edit project": "Редактировать проект",
  "Editor": "Редактор",
  "Engineering": "Инженерия",
  "Engineering Registry": "Инженерный реестр",
  "Enter a canonical PIN.": "Введите канонический PIN.",
  "Enter a position code.": "Введите код положения.",
  "Enter a positive quantity and a unit.": "Введите положительное количество и единицу.",
  "Enter a valid email address.": "Введите действительный адрес.",
  "Enter a variant code.": "Введите код варианта.",
  "Exact child revision": "Точная ревизия компонента",
  "Exact children in this baseline": "Точные компоненты этого базового состава",
  "Existing codes…": "Существующие коды…",
  "Existing hand, used in V": "Существующая кисть, использованная в V",
  "Existing part": "Существующая деталь",
  "Explain": "Объяснить",
  "External aliases": "Внешние номера",
  "External part number": "Внешний номер детали",
  "Filters": "Фильтры",
  "Find an existing part": "Найти существующую деталь",
  "Find parts": "Найти детали",
  "Find {value0}": "Найти {value0}",
  "For an unrelated part, leave Related part empty to allocate a new number.": "Для несвязанной детали оставьте поле связанной детали пустым, чтобы получить новый номер.",
  "Forearm cover": "Крышка предплечья",
  "Front view · left/right is the robot’s own left/right": "Вид спереди · стороны относительно робота",
  "Front view. The robot’s right hand is on the left of the drawing; its left hand is on the right.": "Вид спереди. Правая кисть робота слева на чертеже, левая — справа.",
  "Google account email": "Электронная почта Google",
  "Google could not verify this sign-in. Try again.": "Google не подтвердил вход. Попробуйте снова.",
  "Google sign-in could not load. Check your connection and try again.": "Не удалось загрузить вход Google. Проверьте соединение и попробуйте снова.",
  "Google sign-in is not configured.": "Вход Google не настроен.",
  "Hand identities": "Идентичности кистей",
  "Head casing": "Корпус головы",
  "Hide": "Скрыть",
  "Historical rename": "Историческое переименование",
  "History": "История",
  "Hole Ø6 mm · tolerance ±": "Отверстие Ø6 mm · допуск ±",
  "Identity family": "Семейство идентичностей",
  "Identity history examples": "Примеры истории идентичности",
  "Illustrative example · not your registry": "Иллюстративный пример · не ваш реестр",
  "Imperial": "Имперские",
  "Interactive robot part numbers": "Интерактивные номера деталей робота",
  "Invitation link": "Ссылка приглашения",
  "Invitation not found.": "Приглашение не найдено.",
  "Invite person": "Пригласить пользователя",
  "Issue part number": "Выдать номер детали",
  "Issue variant": "Выдать вариант",
  "Issuing the cover beneath it appends": "Номер крышки под этой сборкой дополняется",
  "It does not tell you where it is used now.": "Это не определяет текущее место использования.",
  "Keep the part number and name columns; each column may appear only once.": "Оставьте столбцы номера и названия; каждый столбец должен быть только один раз.",
  "Knee pin ×2": "Коленный штифт ×2",
  "Language": "Язык",
  "Left / right": "Левая / правая",
  "Left hand": "Левая кисть",
  "Left hand · 1 each · wrist": "Левая кисть · 1 шт. · запястье",
  "Loading…": "Загрузка…",
  "Main navigation": "Основная навигация",
  "Material": "Материал",
  "Meaning": "Значение",
  "Measurement units": "Единицы измерения",
  "Members": "Участники",
  "Metric": "Метрические",
  "Move {column} down": "Переместить {column} ниже",
  "Move {column} up": "Переместить {column} выше",
  "Name": "Название",
  "Navigation": "Навигация",
  "Neither family membership nor a variant code promises interchangeability.": "Принадлежность к семейству и код варианта не гарантируют взаимозаменяемость.",
  "New assembly": "Новая сборка",
  "New camera in V2": "Новая камера в V2",
  "New camera, first numbered in V2": "Новая камера, впервые пронумерованная в V2",
  "New codes are registered by a company owner.": "Новые коды регистрирует владелец компании.",
  "New company": "Новая компания",
  "New configuration": "Новая конфигурация",
  "New part": "Новая деталь",
  "New product version": "Новая версия изделия",
  "New project": "Новый проект",
  "New revision": "Новая ревизия",
  "New version": "Новая версия",
  "No choices available.": "Нет доступных вариантов.",
  "No parts yet.": "Деталей пока нет.",
  "No selected occurrences.": "Использования деталей не выбраны.",
  "None": "Нет",
  "Not confirmed yet. Retry the saved change to resolve it safely.": "Пока не подтверждено. Повторите сохранённое изменение, чтобы безопасно определить результат.",
  "Not found.": "Не найдено.",
  "Notes": "Примечания",
  "Numbering beneath an assembly does not place the cover in its structure. Adding an occurrence is separate; reuse elsewhere keeps this P/N.": "Нумерация под сборкой не добавляет крышку в её структуру. Добавление выполняется отдельно; повторное использование сохраняет этот номер.",
  "Numbering concept": "Понятие нумерации",
  "Numbering path": "Путь нумерации",
  "Obsolete": "Устаревший",
  "Old text": "Старый текст",
  "Only !REV changes.": "Меняется только !REV.",
  "Only company owners can manage membership.": "Только владельцы компании могут управлять участниками.",
  "Only the configured administrator can create companies.": "Только назначенный администратор может создавать компании.",
  "Open PIN": "Открыть PIN",
  "Open navigation": "Открыть навигацию",
  "Open project explorer": "Открыть дерево проектов",
  "Organization": "Организация",
  "Original identity": "Исходная идентичность",
  "Overview": "Обзор",
  "Owner": "Владелец",
  "P/N prefix": "Префикс номера",
  "P/N preview": "Предварительный номер",
  "Page not found": "Страница не найдена",
  "Part": "Деталь",
  "Part name": "Название детали",
  "Part number": "Номер детали",
  "Part number preview": "Предварительный просмотр номера детали",
  "Part number ↑": "Номер детали ↑",
  "Part number ↓": "Номер детали ↓",
  "Part number, name, material or alias": "Номер, название, материал или внешний номер",
  "Part numbering guide": "Справочник нумерации деталей",
  "Part prefixes change together; controlled historical identifiers keep redirects.": "Префиксы деталей меняются вместе; контролируемые исторические номера сохраняют перенаправления.",
  "Part record": "Карточка детали",
  "Part section": "Раздел детали",
  "Part type": "Тип детали",
  "Parts": "Детали",
  "Parts first numbered in this product version.": "Детали, впервые пронумерованные в этой версии изделия.",
  "Per page": "На странице",
  "Personal preferences": "Личные настройки",
  "Piece": "Деталь",
  "Piece part": "Отдельная деталь",
  "Piece parts cannot have controlled children.": "Отдельные детали не могут содержать контролируемые компоненты.",
  "Piece parts do not have assembly configurations.": "Отдельные детали не имеют конфигураций сборок.",
  "Position": "Позиция",
  "Position code": "Код положения",
  "Position codes contain 1–12 uppercase letters.": "Коды положения содержат от 1 до 12 заглавных латинских букв.",
  "Product shown": "Показанное изделие",
  "Product version": "Версия продукта",
  "Product versions": "Версии продукта",
  "Project": "Проект",
  "Project / product version": "Проект / версия изделия",
  "Project code": "Код проекта",
  "Project explorer": "Дерево проектов",
  "Project name": "Название проекта",
  "Project settings": "Настройки проекта",
  "Project workspace": "Рабочее пространство проекта",
  "Projects": "Проекты",
  "Quantity": "Количество",
  "Quantity and position belong to each occurrence, not to the part’s identity. Both knees select revision 1.": "Количество и положение принадлежат каждому использованию, а не идентичности детали. Оба колена выбирают ревизию 1.",
  "Quantity must be positive, at most one billion, with no more than six decimal places.": "Количество должно быть положительным, не больше миллиарда, не более чем с шестью десятичными знаками.",
  "ROBOT project": "Проект ROBOT",
  "Reason for changing the code": "Причина изменения кода",
  "Reason for correcting the code": "Причина исправления кода",
  "Reason for correcting version number": "Причина исправления номера версии",
  "Regional format": "Региональный формат",
  "Register code": "Зарегистрировать код",
  "Register variant code": "Зарегистрировать код варианта",
  "Registered meanings cannot be reassigned after use.": "После использования значения зарегистрированных кодов нельзя менять.",
  "Registered {value0} codes": "Зарегистрированные коды: {value0}",
  "Registry": "Реестр",
  "Related identities are not automatically interchangeable.": "Связанные идентичности не являются автоматически взаимозаменяемыми.",
  "Related part": "Связанная деталь",
  "Release configuration": "Выпустить конфигурацию",
  "Release each selected child revision before releasing this assembly.": "Выпустите все выбранные ревизии компонентов перед выпуском сборки.",
  "Release the assembly revision before releasing this configuration.": "Выпустите ревизию сборки перед выпуском конфигурации.",
  "Released": "Выпущено",
  "Released arm baseline": "Выпущенный базовый состав руки",
  "Released configurations cannot be changed. Create a new configuration.": "Выпущенные конфигурации нельзя менять. Создайте новую.",
  "Released definitions stay unchanged. Create a new revision to make changes.": "Выпущенные определения неизменны. Для изменений создайте новую ревизию.",
  "Released structures stay unchanged. Create a new revision.": "Выпущенные структуры неизменны. Создайте новую ревизию.",
  "Reload saved preferences": "Загрузить сохранённые настройки",
  "Reload structure": "Перезагрузить структуру",
  "Remove": "Удалить",
  "Remove access": "Удалить доступ",
  "Remove alias": "Удалить внешний номер",
  "Remove external alias?": "Удалить внешний номер?",
  "Remove from assembly": "Удалить из сборки",
  "Remove from assembly?": "Удалить из сборки?",
  "Remove saved search": "Удалить сохранённый поиск",
  "Remove saved search?": "Удалить сохранённый поиск?",
  "Remove {value0}'s access?": "Удалить доступ для {value0}?",
  "Replace invitation link?": "Заменить ссылку приглашения?",
  "Replace link": "Заменить ссылку",
  "Replacement": "Замена",
  "Replacement conditions": "Условия замены",
  "Results per page": "Результатов на странице",
  "Retired": "Выведен",
  "Retry saved change": "Повторить сохранённое изменение",
  "Reuse & structure": "Повторное использование и структура",
  "Reuse parts": "Повторно использовать детали",
  "Reuse source": "Источник повторного использования",
  "Rev": "Рев.",
  "Revision": "Ревизия",
  "Revision and configuration numbers must be positive.": "Номера ревизий и конфигураций должны быть положительными.",
  "Revision structures are selected by revision, not by project snapshot.": "Структуры ревизий выбираются по ревизии, а не снимку проекта.",
  "Revisions": "Ревизии",
  "Revoke invitation": "Отозвать приглашение",
  "Revoke invitation?": "Отозвать приглашение?",
  "Right hand": "Правая кисть",
  "Riveted": "Клёпаное",
  "Riveted assembly": "Клёпаная сборка",
  "Riveted chest panel": "Клёпаная панель груди",
  "Robot numbering guide": "Справочник нумерации робота",
  "Same assembly and revision, different frozen selections.": "Та же сборка и ревизия, разные зафиксированные наборы.",
  "Same cover identity": "Та же идентичность крышки",
  "Save": "Сохранить",
  "Save as a new search": "Сохранить как новый поиск",
  "Save changes": "Сохранить изменения",
  "Save configuration": "Сохранить конфигурацию",
  "Save project": "Сохранить проект",
  "Save replacement": "Сохранить замену",
  "Save search": "Сохранить поиск",
  "Saved change recovery": "Восстановление сохранённого изменения",
  "Saved searches": "Сохранённые поиски",
  "Saving…": "Сохранение…",
  "Search": "Поиск",
  "Search columns and order": "Столбцы поиска и их порядок",
  "Search company parts": "Искать детали компании",
  "Search filters": "Фильтры поиска",
  "Search name": "Название поиска",
  "Search order": "Порядок поиска",
  "Search part numbers or names": "Искать номера или названия деталей",
  "Searching…": "Поиск…",
  "Search…": "Поиск…",
  "Select a cover to see its P/N on the robot. Geometry can look alike while material and engineering definition differ.": "Выберите крышку, чтобы увидеть её номер на роботе. Схожая форма не означает одинаковый материал или определение.",
  "Select a revision of this assembly.": "Выберите ревизию этой сборки.",
  "Select a variant code registered in this company.": "Выберите код варианта, зарегистрированный в этой компании.",
  "Select an assembly revision.": "Выберите ревизию сборки.",
  "Select an exact child revision.": "Выберите точную ревизию компонента.",
  "Select at least one child occurrence before releasing an assembly configuration.": "Перед выпуском конфигурации сборки выберите хотя бы одно использование компонента.",
  "Selected engineering definition": "Выбранное инженерное определение",
  "Selected revision": "Выбранная ревизия",
  "Send this link to": "Отправьте эту ссылку",
  "Separable": "Разборное",
  "Separable assembly": "Разборная сборка",
  "Several parts use this external alias. Search it and choose the correct part.": "Этот внешний номер имеют несколько деталей. Найдите его и выберите нужную деталь.",
  "Show V": "Показать V",
  "Show all company parts": "Показать все детали компании",
  "Show {column}": "Показать {column}",
  "Showing the first": "Показаны первые",
  "Shown in product version V": "Показано в версии изделия V",
  "Sign in first.": "Сначала войдите.",
  "Sign in to continue.": "Войдите, чтобы продолжить.",
  "Sign in to your engineering workspace.": "Войдите в инженерное рабочее пространство.",
  "Sign in with the Google account named on this invitation.": "Войдите с учётной записью Google, указанной в приглашении.",
  "Sign out": "Выйти",
  "Signing in…": "Вход…",
  "Skip to content": "Перейти к содержимому",
  "Sort": "Сортировка",
  "Standard position meanings cannot be changed.": "Значения стандартных положений нельзя менять.",
  "State": "Состояние",
  "Structure": "Структура",
  "Structure snapshot": "Снимок структуры",
  "Structure snapshot not found.": "Снимок структуры не найден.",
  "Switch to V2: the reused hands and knee pins keep their V1 numbers. Only the new camera receives a V2 number. ROBOT is the project code; V1/V2 are product versions, not part revisions.": "Переключитесь на V2: повторно используемые кисти и коленные штифты сохраняют номера V1. Только новая камера получает номер V2. ROBOT — код проекта; V1/V2 — версии изделия, а не ревизии деталей.",
  "Switch to {value0} appearance": "Переключить оформление: {value0}",
  "Table density": "Плотность таблицы",
  "That record was not found in this company.": "Эта запись не найдена в компании.",
  "The corrected identifier must differ from the current identifier.": "Исправленный идентификатор должен отличаться от текущего.",
  "The correction creates duplicate identifiers.": "Исправление создаёт дубликаты идентификаторов.",
  "The identifier number is outside the supported positive integer range.": "Число в идентификаторе вне поддерживаемого диапазона положительных целых.",
  "The next number changed. Review the updated preview, then issue again.": "Следующий номер изменился. Проверьте обновлённый номер и повторите выдачу.",
  "The number is allocated within its prefix:": "Номер выделяется в пределах префикса:",
  "The old item remains its own record. Example condition: the replacement cover fits only with an adapter. The reverse is not implied; replacement is not an alias.": "Старая деталь сохраняет отдельную запись. Пример условия: новая крышка подходит только с адаптером. Обратная замена не подразумевается; замена — не псевдоним.",
  "The old released definition remains available; an unqualified P/N identifies the item, not “latest revision”.": "Старое выпущенное определение остаётся доступным; номер без уточнения определяет деталь, а не «последнюю ревизию».",
  "The part is saved in the company registry.": "Деталь сохранена в реестре компании.",
  "The pending invitation for": "Приглашение, ожидающее ответа для",
  "The prefix is ROBOT-V1.2A.": "Префикс — ROBOT-V1.2A.",
  "The related family must have the same product version and origin parent.": "Связанное семейство должно иметь ту же версию изделия и исходную родительскую сборку.",
  "The request could not be completed. Retry or reload; confirm any pending change before editing again.": "Не удалось выполнить запрос. Повторите или перезагрузите; перед новым редактированием подтвердите незавершённое изменение.",
  "The request could not be read. Check your input and try again.": "Не удалось прочитать запрос. Проверьте введённые данные и повторите.",
  "The revision and configuration select different assembly baselines.": "Ревизия и конфигурация указывают на разные базовые составы сборки.",
  "The same forearm cover shape in silver aluminium on the left and woven carbon fibre on the right": "Одинаковая форма крышки предплечья: серебристый алюминий слева, тканый углепластик справа",
  "The selected part may replace": "Выбранная деталь может заменять",
  "They share a family number, not an interchangeable identity. “Not sided” omits the qualifier; issuing one side does not issue the other.": "Общий номер семейства не означает взаимозаменяемость. «Без стороны» не добавляет уточнение; выдача одной стороны не создаёт другую.",
  "This PIN was not found in the selected company.": "Этот PIN не найден в выбранной компании.",
  "This baseline uses multiple revisions of the child. Specify !REV explicitly.": "В этом базовом составе есть несколько ревизий компонента. Явно укажите !REV.",
  "This change conflicts with an existing record. Reload and review your changes.": "Изменение конфликтует с существующей записью. Перезагрузите и проверьте изменения.",
  "This child revision is not in the selected parent baseline.": "Этой ревизии компонента нет в выбранном родительском базовом составе.",
  "This code was registered elsewhere. Review its meaning before using it.": "Код зарегистрирован в другом сеансе. Проверьте его значение перед использованием.",
  "This configuration is already released.": "Эта конфигурация уже выпущена.",
  "This destination is read-only or the revision is unavailable.": "Цель доступна только для чтения или ревизия недоступна.",
  "This family number belongs to another family. Issue a related identity explicitly instead.": "Номер принадлежит другому семейству. Создайте связанную идентичность явно.",
  "This identifier is reserved by a historical rename.": "Идентификатор зарезервирован историческим переименованием.",
  "This invitation has expired or been revoked.": "Приглашение истекло или отозвано.",
  "This invitation has expired, was replaced, or is no longer pending.": "Приглашение истекло, заменено или уже не ожидает ответа.",
  "This invitation is no longer pending.": "Это приглашение уже не ожидает ответа.",
  "This is the next available number, not a reservation. The number is checked again when you issue. If another person takes it first, the form stays open with an updated preview.": "Это следующий доступный номер, а не резервирование. При выдаче он проверяется снова. Если его заняли, форма остаётся открытой с обновлённым номером.",
  "This occurrence would create a structure cycle.": "Это использование создало бы цикл в структуре.",
  "This part number already exists. Choose a different variant or position.": "Такой номер уже существует. Выберите другой вариант или положение.",
  "This person is already a member. Change their role in Members.": "Этот человек уже участник. Измените роль в разделе участников.",
  "This product version number is already assigned.": "Этот номер версии изделия уже назначен.",
  "This project code already exists.": "Этот код проекта уже существует.",
  "This record changed. Reload it before saving again.": "Запись изменилась. Перезагрузите её перед сохранением.",
  "This released configuration does not exist.": "Этой выпущенной конфигурации не существует.",
  "This replacement direction already exists.": "Это направление замены уже существует.",
  "This revision does not exist.": "Этой ревизии не существует.",
  "This revision is already released.": "Эта ревизия уже выпущена.",
  "This saved search belongs to another person.": "Этот сохранённый поиск принадлежит другому человеку.",
  "This updates the project's part-number prefixes. Controlled identities retain historical redirects.": "Обновляет префиксы номеров проекта. Контролируемые идентичности сохраняют исторические перенаправления.",
  "Time zone": "Часовой пояс",
  "Try again": "Повторить",
  "Two hands, two identities.": "Две кисти, две идентичности.",
  "Two occurrences, one part": "Два использования, одна деталь",
  "Unit": "Единица",
  "Unsaved search": "Несохранённый поиск",
  "Use PROJECT-V1 followed by unpadded identity nodes.": "Используйте PROJECT-V1, затем узлы идентичности без начальных нулей.",
  "Use a positive product version number.": "Используйте положительный номер версии изделия.",
  "Use a positive, unpadded family number.": "Используйте положительный номер семейства без начальных нулей.",
  "Use a whole number for the search filter.": "Используйте целое число в фильтре поиска.",
  "Use an uppercase code starting with a letter, containing letters, numbers or hyphens (maximum 32 characters).": "Код должен начинаться заглавной латинской буквой и содержать заглавные буквы, цифры или дефисы, до 32 символов.",
  "Use code": "Использовать код",
  "Use number/class, optional !VARIANT and #POSITION, then !REV and !CFG in that order. Leading zeroes and colon qualifiers are not valid.": "Используйте число/тип, необязательные !VARIANT и #POSITION, затем !REV и !CFG в таком порядке. Начальные нули и двоеточия недопустимы.",
  "Using this pin in V2 or another project in the same company keeps": "Использование этого штифта в V2 или другом проекте компании сохраняет",
  "V1 tells you where a part was first numbered.": "V1 показывает, где деталь впервые получила номер.",
  "Variant code": "Код варианта",
  "Variant codes": "Коды вариантов",
  "Variant codes contain uppercase letters and cannot start with REV or CFG.": "Коды вариантов содержат заглавные латинские буквы и не могут начинаться с REV или CFG.",
  "Variants & replacements": "Варианты и замены",
  "Version name": "Название версии",
  "Version name (optional)": "Название версии (необязательно)",
  "Version number": "Номер версии",
  "View parts": "Посмотреть детали",
  "Viewer": "Читатель",
  "Wait for a valid part-number preview.": "Дождитесь корректного предварительного номера детали.",
  "Welded": "Сварное",
  "Welded assembly": "Сварная сборка",
  "Welded torso frame": "Сварной каркас туловища",
  "Where used": "Где используется",
  "With controlled dependencies, old text redirects to the renamed item. !REV1 still resolves that exact historical revision; configurations and descendant numbering are preserved.": "При наличии контролируемых зависимостей старый текст перенаправляет на переименованную деталь. !REV1 по-прежнему открывает точную историческую ревизию; конфигурации и нумерация потомков сохраняются.",
  "Withdraw permission for": "Отозвать разрешение для",
  "Withdraw replacement": "Отозвать замену",
  "Withdraw replacement?": "Отозвать замену?",
  "You are already a member of this company.": "Вы уже участник этой компании.",
  "Your form session expired. Refresh your session, then retry the saved change.": "Сеанс формы завершился. Обновите сеанс, затем повторите сохранённое изменение.",
  "Your preferences changed. Reload before saving again.": "Ваши настройки изменились. Перезагрузите их перед сохранением.",
  "across this company": "во всей компании",
  "and": "и",
  "at {value0}": "в {value0}",
  "dark": "тёмное",
  "distinguish the right-hand and left-hand forms. The two connected labels point to the robot’s own hands, not the viewer’s sides.": "различают правую и левую формы. Выноски указывают на собственные кисти робота, а не на стороны зрителя.",
  "from": "из",
  "from this structure? The original part remains in the company registry.": "из этой структуры? Исходная деталь остаётся в реестре компании.",
  "in this example.": "в этом примере.",
  "is the construction class, not a revision. P is a single piece without controlled children; A, W, G and R are assemblies joined in different ways.": "— тип конструкции, а не ревизия. P — отдельная деталь без контролируемых компонентов; A, W, G и R — сборки с разными способами соединения.",
  "issued.": "выдано.",
  "light": "светлое",
  "match": "совпадение",
  "matches": "совпадений",
  "mm": "mm",
  "of": "из",
  "only under the stated conditions.": "только при указанных условиях.",
  "parts. Search the company to find additional matches.": "деталей. Ищите в компании, чтобы найти другие совпадения.",
  "to replace": "для замены",
  "will lose access to every project and part in this company.": "потеряет доступ ко всем проектам и деталям компании.",
  "will no longer work.": "больше не будет работать.",
  "{field} must contain {minimum}–{maximum} characters.": "{field}: от {minimum} до {maximum} символов.",
  "{value0} added to {value1}.": "{value0} добавлено в {value1}.",
  "{value0} code": "Код: {value0}",
  "{value0} cover example": "Пример крышки: {value0}",
  "{value0} editor": "Редактор: {value0}",
  "{value0} meaning": "Значение: {value0}",
  "{value0} · Rev {value1}": "{value0} · Рев. {value1}",
  "{value0}!REV1": "{value0}!REV1",
  "{value0}!REV{value1}": "{value0}!REV{value1}",
  "· 1 each": "· по 1 шт.",
  "· Refine your search for other matches.": "· Уточните поиск для других совпадений.",
  "· Revision {value0}": "· Ревизия {value0}",
  "!CF": "!CF",
  "!CF changes the identity, not its revision.": "!CF меняет идентичность, а не ревизию.",
  "!CFG{value0}": "!CFG{value0}",
  "!REV1": "!REV1",
  "!REV{value0}": "!REV{value0}",
  "? Its definition and exact child occurrences become immutable. Further changes require a new revision.": "? Определение и точные использования компонентов станут неизменными. Дальнейшие изменения потребуют новой ревизии.",
  "Accept invitation": "Принять приглашение",
  "Accepting…": "Принятие…",
  "Actions": "Действия",
  "Actions for {value0}": "Действия для {value0}",
  "Add description": "Добавить описание",
  "Add external alias": "Добавить внешний номер",
  "An origin parent is selected.": "Выбрана исходная родительская сборка.",
  "Applicability / effectivity": "Применимость / действие",
  "Apply identity correction": "Применить исправление идентичности",
  "Assembly revision": "Ревизия сборки",
  "Both covers share": "Обе крышки имеют общий",
  "Change role": "Изменить роль",
  "Checking number…": "Проверка номера…",
  "Child REV": "Рев. компонента",
  "Choose a project": "Выберите проект",
  "Choose a revision to inspect its exact definition.": "Выберите ревизию для просмотра её точного определения.",
  "Choose a revision to view its exact structure.": "Выберите ревизию для просмотра её точной структуры.",
  "Choose an assembly in the selected product version.": "Выберите сборку в выбранной версии изделия.",
  "Choose an exact assembly revision.": "Выберите точную ревизию сборки.",
  "Choose another company": "Выбрать другую компанию",
  "Collapse": "Свернуть",
  "Company access unavailable": "Доступ к компании недоступен",
  "Copied.": "Скопировано.",
  "Copy link": "Копировать ссылку",
  "Copy was unavailable. Select the link and copy it manually.": "Копирование недоступно. Выделите ссылку и скопируйте вручную.",
  "Correct identity": "Исправить идентичность",
  "Custom position…": "Своё положение…",
  "Definition": "Определение",
  "Details for {value0}": "Сведения о {value0}",
  "Edit": "Редактирование",
  "Edit alias {value}": "Редактировать внешний номер {value}",
  "Edit definition": "Редактировать определение",
  "Edit external alias": "Редактировать внешний номер",
  "Empty definition": "Пустое определение",
  "Expand": "Развернуть",
  "Family number": "Номер семейства",
  "Freeze CFG": "Зафиксировать CFG",
  "Google sign-in is not configured. The administrator needs to restore the sign-in configuration.": "Вход Google не настроен. Администратор должен восстановить настройки входа.",
  "Identity": "Идентичность",
  "In this example company, CF is registered as “carbon fibre”. Other companies may register different meanings.": "В компании из примера CF зарегистрирован как «углепластик». Другие компании могут иметь другое значение.",
  "Include selected revision": "Включить выбранную ревизию",
  "Invitations": "Приглашения",
  "Join": "Соединение",
  "Left": "Левая",
  "Next": "Далее",
  "No child parts.": "Нет дочерних деталей.",
  "No companies yet.": "Компаний пока нет.",
  "No configurations yet.": "Конфигураций пока нет.",
  "No external aliases.": "Внешних номеров нет.",
  "No invitations.": "Приглашений нет.",
  "No matching choices.": "Подходящих вариантов нет.",
  "No matching parts.": "Подходящих деталей нет.",
  "No parts in this structure yet.": "В этой структуре пока нет деталей.",
  "No product versions in this project.": "В этом проекте нет версий изделия.",
  "No product versions yet.": "Версий изделия пока нет.",
  "No projects yet.": "Проектов пока нет.",
  "No replacement relationships.": "Связей замены нет.",
  "No variant code": "Без кода варианта",
  "No variant codes registered.": "Коды вариантов не зарегистрированы.",
  "Not reserved": "Не зарезервировано",
  "Numbered directly under the product version.": "Номер непосредственно под версией изделия.",
  "Open assembly {value0}": "Открыть сборку {value0}",
  "Open resolved configuration": "Открыть найденную конфигурацию",
  "Origin product version": "Исходная версия изделия",
  "Other positions": "Другие положения",
  "Other positions add a distinct identity qualifier: #N/#S, #W/#E, #FRONT/#MIDLONG/#REAR, and #TOP/#MIDVERT/#BOTTOM. The two Mid choices belong to different axes. Custom codes have a company-defined meaning. This is not the location or position number of a reused part in an assembly.": "Другие положения добавляют уточнение идентичности: #N/#S, #W/#E, #FRONT/#MIDLONG/#REAR и #TOP/#MIDVERT/#BOTTOM. Два «средних» относятся к разным осям. Свои коды имеют значение, определённое компанией. Это не место использования детали в сборке.",
  "Other positions…": "Другие положения…",
  "Page {page} of {pages}": "Страница {page} из {pages}",
  "Part / P/N": "Деталь / номер",
  "Part section not found.": "Раздел детали не найден.",
  "Parts in {value0}": "Детали в {value0}",
  "Person": "Человек",
  "Piece parts have no child structure.": "Отдельные детали не имеют дочерней структуры.",
  "Position for occurrence {value0}": "Положение использования {value0}",
  "Previous": "Назад",
  "Product root": "Корень изделия",
  "Product structure": "Структура продукта",
  "Qty": "Кол-во",
  "Quantity for occurrence {value0}": "Количество использования {value0}",
  "Quantity for {value0} {value1}": "Количество для {value0} {value1}",
  "Quantity saved for {value0}.": "Количество для {value0} сохранено.",
  "Read-only access": "Доступ только для чтения",
  "Reason for correction": "Причина исправления",
  "Registered variant": "Зарегистрированный вариант",
  "Release": "Выпустить",
  "Release revision": "Выпустить ревизию",
  "Remove alias {value}": "Удалить внешний номер {value}",
  "Remove from assembly {value0} {value1}": "Удалить из сборки {value0} {value1}",
  "Remove selected occurrence": "Удалить выбранное использование",
  "Remove {value0}'s access": "Удалить доступ для {value0}",
  "Replace invitation link for {value0}": "Заменить ссылку приглашения для {value0}",
  "Reset quantity for {value0}": "Сбросить количество для {value0}",
  "Resolved definition: REV": "Найденное определение: REV",
  "Results: {count}": "Результаты: {count}",
  "Retry preview": "Повторить предварительный просмотр",
  "Revoke": "Отозвать",
  "Revoke invitation for {value0}": "Отозвать приглашение для {value0}",
  "Right": "Правая",
  "Role": "Роль",
  "Same family number, different identities.": "Тот же номер семейства, разные идентичности.",
  "Save quantity for {value0}": "Сохранить количество для {value0}",
  "Search pages": "Страницы поиска",
  "Source product version": "Исходная версия изделия",
  "Source project": "Исходный проект",
  "Start from": "Начать с",
  "Structural class": "Тип конструкции",
  "The invitation was created, but its one-time link cannot be shown again. Use Replace link to generate another.": "Приглашение создано, но одноразовую ссылку больше нельзя показать. Используйте замену ссылки для создания новой.",
  "This invitation link is incomplete. Ask the company owner for a replacement link.": "Ссылка приглашения неполная. Попросите владельца компании предоставить новую.",
  "This part is not used in a structure or configuration.": "Эта деталь не используется в структурах или конфигурациях.",
  "This structure is read-only. Choose a draft revision to edit.": "Структура только для чтения. Для редактирования выберите черновик ревизии.",
  "Unit & position": "Единица и положение",
  "Unit for occurrence {value0}": "Единица использования {value0}",
  "Unspecified": "Не указано",
  "Unused assignments are corrected directly. Controlled identities are renamed atomically with historical redirects; revisions, configurations, and usage references stay attached.": "Неиспользованные назначения исправляются напрямую. Контролируемые идентичности переименовываются атомарно с историческими перенаправлениями; ревизии, конфигурации и использования сохраняются.",
  "Use product-version root": "Использовать корень версии изделия",
  "Variant": "Вариант",
  "Versions": "Версии",
  "You do not have company access yet. Open an invitation from a company owner.": "У вас пока нет доступа к компании. Откройте приглашение от её владельца.",
  "Your account does not have access to this company.": "Ваша учётная запись не имеет доступа к этой компании.",
  "and its selected exact child revisions? The assembly and every child revision must already be released.": "и выбранные точные ревизии компонентов? Сборка и все ревизии компонентов должны быть уже выпущены.",
  "as": "как",
  "because the new cover was explicitly numbered as related to the existing one.": "поскольку новую крышку явно пронумеровали как связанную с существующей.",
  "may replace": "может заменять",
  "using": "с использованием",
  "· Expires": "· Срок действия",
  "Sign in again": "Войти снова",
  "Refresh session": "Обновить сеанс",
  "Connection interrupted. Check the saved change before making another edit.": "Соединение прервано. Проверьте сохранённое изменение перед новым редактированием.",
  "The request could not be completed.": "Не удалось выполнить запрос.",
  "Resolve the saved change shown above before making another edit.": "Подтвердите результат сохранённого изменения перед новым редактированием.",
  "Browser storage is unavailable. Enable it before saving a change.": "Хранилище браузера недоступно. Включите его перед сохранением изменения.",
  "No position": "Без положения",
  "Not specified.": "Не указано.",
  "No description.": "Без описания.",
  "Field": "Поле",
  "Choose…": "Выберите…",
  "Choose": "Выбрать",
  "Complete {field}.": "Заполните поле «{field}».",
  "Check the value of {field}.": "Проверьте значение поля «{field}».",
  "Do not submit another edit until this change is confirmed.": "Не отправляйте новые изменения до подтверждения этого.",
  "CFG1 keeps cover REV1; CFG2 selects cover REV2. A configuration is not a new part number and applies only to assemblies.": "CFG1 сохраняет крышку REV1; CFG2 выбирает REV2. Конфигурация не является новым номером и применяется только к сборкам.",
  "No variant": "Без варианта",
  "Company created": "Компания создана",
  "Company updated": "Компания обновлена",
  "Variant code registered": "Код варианта зарегистрирован",
  "Position code registered": "Код положения зарегистрирован",
  "Role changed": "Роль изменена",
  "Membership removed": "Доступ участника удалён",
  "Invitation created": "Приглашение создано",
  "Invitation link replaced": "Ссылка приглашения заменена",
  "Invitation revoked": "Приглашение отозвано",
  "Invitation accepted": "Приглашение принято",
  "Revision created": "Ревизия создана",
  "Revision definition updated": "Определение ревизии обновлено",
  "Revision released": "Ревизия выпущена",
  "Structure occurrence added": "Деталь добавлена в структуру",
  "Structure occurrence updated": "Использование детали обновлено",
  "Structure occurrence removed": "Деталь удалена из структуры",
  "Configuration created": "Конфигурация создана",
  "Configuration updated": "Конфигурация обновлена",
  "Configuration released": "Конфигурация выпущена",
  "Replacement recorded": "Замена записана",
  "Replacement withdrawn": "Замена отозвана",
  "Project created": "Проект создан",
  "Project updated": "Проект обновлён",
  "Product version created": "Версия изделия создана",
  "Product version updated": "Версия изделия обновлена",
  "Part issued": "Номер детали выдан",
  "Part details updated": "Сведения детали обновлены",
  "alias-added": "Внешний номер добавлен",
  "alias-edited": "Внешний номер изменён",
  "alias-removed": "Внешний номер удалён",
  "Identity renamed": "Идентичность переименована",
  "Assignment corrected": "Назначение исправлено",
  "North": "Север",
  "South": "Юг",
  "West": "Запад",
  "East": "Восток",
  "Front": "Перед",
  "Rear": "Зад",
  "Mid": "Середина",
  "Top": "Верх",
  "Bottom": "Низ",
  "Side": "Сторона",
  "North / south": "Север / юг",
  "West / east": "Запад / восток",
  "Front / rear": "Перед / зад",
  "Top / bottom": "Верх / низ",
  "Custom": "Своё",
  "Family, not an orderable P/N": "Семейство, а не номер для заказа",
  "Pending": "Ожидает",
  "Accepted": "Принято",
  "Revoked": "Отозвано",
  "Expired": "Срок истёк",
  "Edit revision definition": "Изменить определение ревизии",
  "Release revision?": "Выпустить ревизию?",
  "Release configuration?": "Выпустить конфигурацию?",
  "A complete SHA-256 checksum is required.": "Требуется полная контрольная сумма SHA-256.",
  "Add comment": "Добавить комментарий",
  "Add file": "Добавить файл",
  "All": "Все",
  "Applicability": "Применяемость",
  "Applicability must refer to a configuration of the owning part.": "Применяемость должна ссылаться на конфигурацию детали, которой принадлежит документ.",
  "Applicability must refer to a revision of the owning part.": "Применяемость должна ссылаться на ревизию детали, которой принадлежит документ.",
  "Applicability notes": "Примечания по применяемости",
  "Attachment": "Вложение",
  "Cancel upload": "Отменить загрузку",
  "Cancelled": "Отменено",
  "Checking file…": "Проверка файла…",
  "Choose Draft or Issued status.": "Выберите статус «Черновик» или «Выпущено».",
  "Choose Source, Rendition or Attachment.": "Выберите «Исходный файл», «Версия для просмотра» или «Вложение».",
  "Choose a draft document or production job for this file.": "Выберите черновик документа или производственное задание для этого файла.",
  "Choose a file of this revision.": "Выберите файл этой ревизии.",
  "Choose a registered document type.": "Выберите зарегистрированный тип документа.",
  "Choose a supported document owner.": "Выберите поддерживаемого владельца документа.",
  "Choose a valid results page and a positive page size.": "Выберите допустимую страницу результатов и положительное число результатов на странице.",
  "Choose an issued revision of this document.": "Выберите выпущенную ревизию этого документа.",
  "Choose the viewed revision of this document.": "Выберите просматриваемую ревизию этого документа.",
  "Choose this company as the document owner.": "Выберите эту компанию владельцем документа.",
  "Clear applicability references": "Очистить ссылки применяемости",
  "Comment": "Комментарий",
  "Comment history": "История комментария",
  "Comment removed": "Комментарий удалён",
  "Copy this revision into a shared editable draft?": "Скопировать эту ревизию в общий редактируемый черновик?",
  "Create document": "Создать документ",
  "Create shared draft": "Создать общий черновик",
  "Deleted comments retain their history and cannot be edited.": "История удалённых комментариев сохраняется; редактировать их нельзя.",
  "Discussion": "Обсуждение",
  "Document comment added": "Добавлен комментарий к документу",
  "Document comment deleted": "Удалён комментарий к документу",
  "Document comment edited": "Изменён комментарий к документу",
  "Document created": "Документ создан",
  "Document draft created": "Черновик документа создан",
  "Document draft updated": "Черновик документа обновлён",
  "Document file": "Файл документа",
  "Document file linked": "Файл связан с документом",
  "Document file unlinked": "Связь файла с документом удалена",
  "Document files published": "Файлы документа опубликованы",
  "Document files unpublished": "Публичный доступ к файлам документа прекращён",
  "Document information": "Сведения о документе",
  "Document issued": "Документ выпущен",
  "Document number": "Номер документа",
  "Document reader": "Просмотр документа",
  "Document type": "Тип документа",
  "Document type registered": "Тип документа зарегистрирован",
  "Documents": "Документы",
  "Download {name}": "Скачать {name}",
  "Edit comment": "Редактировать комментарий",
  "Edit draft": "Редактировать черновик",
  "Edit history": "История изменений",
  "Exact engineering applicability": "Точная инженерная применяемость",
  "Exact revision": "Точная ревизия",
  "File": "Файл",
  "File name": "Имя файла",
  "File purpose": "Назначение файла",
  "File size must be between 1 byte and 20 GiB.": "Размер файла должен быть от 1 байта до 20 ГиБ.",
  "File storage is not configured.": "Хранилище файлов не настроено.",
  "File unavailable": "Файл недоступен",
  "Files": "Файлы",
  "Files available to anyone with the public link": "Файлы доступны всем, у кого есть публичная ссылка",
  "Files can only be added to a draft document.": "Файлы можно добавлять только в черновик документа.",
  "Identifier filter": "Фильтр по идентификатору",
  "Issue revision": "Выпустить ревизию",
  "Issue this exact revision? Its metadata and files will become immutable.": "Выпустить именно эту ревизию? Её метаданные и файлы больше нельзя будет изменить.",
  "Issued": "Выпущено",
  "Issued revisions are immutable. Create a shared draft to make changes.": "Выпущенные ревизии нельзя изменять. Для внесения изменений создайте общий черновик.",
  "Link at least one verified file before issuing.": "Перед выпуском прикрепите хотя бы один проверенный файл.",
  "New file": "Новый файл",
  "No comments yet.": "Комментариев пока нет.",
  "No files in this revision.": "В этой ревизии нет файлов.",
  "No published files.": "Нет опубликованных файлов.",
  "No revisions available.": "Нет доступных ревизий.",
  "Only an unfinished upload can be cancelled.": "Можно отменить только незавершённую загрузку.",
  "Only issued files can be published.": "Опубликовать можно только файлы выпущенных ревизий.",
  "Only length- and SHA-256-verified immutable files can be linked or issued.": "Прикрепить или выпустить можно только неизменяемые файлы с проверенным размером и контрольной суммой SHA-256.",
  "Open public link": "Открыть публичную ссылку",
  "Owner kind": "Тип владельца",
  "Page {page} · {count} documents": "Страница {page} · Документов: {count}",
  "Part revision": "Ревизия детали",
  "Pause": "Приостановить",
  "Paused": "Приостановлено",
  "Preview is not available for this file. Download it instead.": "Предварительный просмотр этого файла недоступен. Скачайте его.",
  "Preview unavailable. Download the file to view it.": "Предварительный просмотр недоступен. Скачайте файл для просмотра.",
  "Public description": "Публичное описание",
  "Public links": "Публичные ссылки",
  "Public title": "Публичное название",
  "Publication not found.": "Публикация не найдена.",
  "Publish selected files": "Опубликовать выбранные файлы",
  "Published document not found.": "Опубликованный документ не найден.",
  "Published file not found.": "Опубликованный файл не найден.",
  "Register document type": "Зарегистрировать тип документа",
  "Reload revision": "Перезагрузить ревизию",
  "Remove comment": "Удалить комментарий",
  "Remove file": "Удалить файл",
  "Remove this comment? Its edit history is retained.": "Удалить этот комментарий? История его изменений сохранится.",
  "Remove this file from the draft? Earlier issued revisions keep their files.": "Удалить этот файл из черновика? Файлы ранее выпущенных ревизий сохранятся.",
  "Remove {name}": "Удалить {name}",
  "Rendition": "Версия для просмотра",
  "Resume this upload with the recorder who started it.": "Возобновите эту загрузку от имени регистратора, который её начал.",
  "Resume upload": "Возобновить загрузку",
  "Revision unavailable": "Ревизия недоступна",
  "Revision {number}": "Ревизия {number}",
  "Revision {number} · {status}": "Ревизия {number} · {status}",
  "SHA-256": "SHA-256",
  "Search documents": "Поиск документов",
  "Select distinct issued files to publish.": "Выберите разные файлы выпущенной ревизии для публикации.",
  "Select files from this exact issued revision.": "Выберите файлы именно этой выпущенной ревизии.",
  "Select the same file to resume this upload.": "Выберите тот же файл, чтобы возобновить загрузку.",
  "Source": "Исходный файл",
  "Status": "Статус",
  "Stop subsequent access through this public link? Already downloaded copies are not removed.": "Прекратить дальнейший доступ по этой публичной ссылке? Уже скачанные копии не будут удалены.",
  "That document revision was not found in this company.": "Эта ревизия документа не найдена в этой компании.",
  "The configuration must select the exact applicability revision.": "Конфигурация должна указывать точную ревизию применяемости.",
  "The document input changed during capture. Retry the same request.": "Данные документа изменились во время записи. Повторите тот же запрос.",
  "The file upload is not complete.": "Загрузка файла не завершена.",
  "The issued files no longer match their immutable manifest.": "Файлы выпущенной ревизии больше не соответствуют их неизменяемому манифесту.",
  "The issued manifest failed integrity verification.": "Манифест выпущенной ревизии не прошёл проверку целостности.",
  "The uploaded file checksum does not match. Cancel this upload and select the original file again.": "Контрольная сумма загруженного файла не совпадает. Отмените эту загрузку и снова выберите исходный файл.",
  "The uploaded file is unavailable.": "Загруженный файл недоступен.",
  "The verified file must belong to this document.": "Проверенный файл должен принадлежать этому документу.",
  "This comment is already deleted.": "Этот комментарий уже удалён.",
  "This document already has a shared draft.": "У этого документа уже есть общий черновик.",
  "This document numbering sequence is exhausted.": "Последовательность нумерации этих документов исчерпана.",
  "This file is not available.": "Этот файл недоступен.",
  "This file is unavailable. Contact the company owner.": "Этот файл недоступен. Обратитесь к владельцу компании.",
  "This revision changed. Reload it before publishing.": "Эта ревизия изменилась. Перезагрузите её перед публикацией.",
  "This upload cannot be verified.": "Эту загрузку невозможно проверить.",
  "This upload is no longer writable.": "В эту загрузку больше нельзя записывать данные.",
  "This upload was not found.": "Эта загрузка не найдена.",
  "Title": "Название",
  "Title filter": "Фильтр по названию",
  "Type code": "Код типа",
  "Type name": "Название типа",
  "Unpublish": "Прекратить публикацию",
  "Unpublished": "Публикация прекращена",
  "Upload file": "Загрузить файл",
  "Uploaded": "Загружено",
  "Uploading…": "Загрузка…",
  "Use a file name without a path or control characters.": "Укажите имя файла без пути и управляющих символов.",
  "Use a file name without directory separators.": "Укажите имя файла без разделителей каталогов.",
  "Use an uppercase alphanumeric type code starting with a letter.": "Укажите код типа из заглавных латинских букв и цифр, начинающийся с буквы.",
  "Verified": "Проверено",
  "Verifying file…": "Подтверждение целостности файла…",
  "View draft": "Просмотреть черновик",
  "file-upload-created": "Начата загрузка файла",
  "file-verified": "Файл проверен",
  "{bytes} bytes": "Байт: {bytes}",
  "No matching documents.": "Нет подходящих документов.",
  "No documents yet.": "Документов пока нет.",
  "The revision’s applicability details could not be loaded. Try again.": "Не удалось загрузить сведения о применяемости ревизии. Попробуйте ещё раз.",
  "Comment authors could not be loaded. Try again.": "Не удалось загрузить авторов комментариев. Попробуйте ещё раз.",
  "Comment history authors could not be loaded. Try again.": "Не удалось загрузить авторов изменений комментария. Попробуйте ещё раз.",
  "Choose a saved search": "Выберите сохранённый поиск",
  "This saved search belongs to another person or collection.": "Этот сохранённый поиск принадлежит другому пользователю или коллекции.",
  "Choose a saved parts search.": "Выберите сохранённый поиск деталей.",
  "Supply document search filters.": "Укажите фильтры поиска документов.",
  "Pages": "Страницы",
  "{from}–{to} of {total}": "{from}–{to} из {total}",
  "Choose lot": "Выбрать партию",
  "Choose material": "Выбрать материал",
  "No matches": "Совпадений нет",
  "Stock": "Запасы",
  "Lots": "Партии",
  "Materials": "Материалы",
  "Supplier": "Поставщик",
  "Material identifier": "Идентификатор материала",
  "Specification": "Спецификация",
  "Reload latest versions": "Загрузить актуальные версии",
  "Edit material": "Редактировать материал",
  "Create material revision": "Создать ревизию материала",
  "Edit material revision": "Редактировать ревизию материала",
  "Release material revision": "Выпустить ревизию материала",
  "Create lot": "Создать партию",
  "Choose an exact material revision.": "Выберите конкретную ревизию материала.",
  "Lot identifier": "Идентификатор партии",
  "Balances": "Остатки",
  "No stock recorded": "Запасы не зарегистрированы",
  "Genealogy": "Происхождение партий",
  "No linked lots": "Связанных партий нет",
  "To": "К",
  "Reversed": "Сторнировано",
  "Movement details": "Данные движения запасов",
  "Record history": "История записи",
  "Movements": "Движения запасов",
  "Movement type": "Тип движения запасов",
  "No movements recorded": "Движения запасов не зарегистрированы",
  "Original movement": "Исходное движение запасов",
  "Replaced movement": "Заменённое движение запасов",
  "Reversal": "Сторнирование",
  "Reverse movement": "Сторнировать движение запасов",
  "Record replacement": "Зарегистрировать замену",
  "Movement warnings unavailable": "Предупреждения о движении запасов недоступны",
  "Warnings": "Предупреждения",
  "Actual quantity": "Фактическое количество",
  "Location": "Место хранения",
  "Disposition": "Статус пригодности",
  "Use balance location": "Использовать место хранения остатка",
  "Wait for the latest balances.": "Дождитесь актуальных остатков.",
  "Choose a lot for every quantity.": "Выберите партию для каждого количества.",
  "Source {number}": "Источник {number}",
  "Remove source": "Удалить источник",
  "Add source": "Добавить источник",
  "Output {number}": "Выход {number}",
  "Remove output": "Удалить выход",
  "Add output": "Добавить выход",
  "Destination location": "Место назначения",
  "Source reference": "Ссылка на источник",
  "Reason": "Причина",
  "Reload latest balances": "Загрузить актуальные остатки",
  "Receipt": "Поступление",
  "Accept": "Принять",
  "Quarantine": "Поместить на карантин",
  "Transfer": "Перемещение",
  "Consume": "Списать в производство",
  "Scrap": "Списать в брак",
  "Split": "Разделить",
  "Merge": "Объединить",
  "MaterialLots": "Партии материалов",
  "Receipts": "Поступления",
  "Create material": "Создать материал",
  "Search lots": "Поиск партий",
  "Search materials": "Поиск материалов",
  "Select a lot": "Выберите партию",
  "Select a material": "Выберите материал",
  "Supplier reference": "Номер у поставщика",
  "Supplier lot reference": "Номер партии поставщика",
  "Material created": "Материал создан",
  "Material renamed": "Материал переименован",
  "Material revision created": "Ревизия материала создана",
  "Material revision edited": "Ревизия материала отредактирована",
  "Material revision released": "Ревизия материала выпущена",
  "Lot created": "Партия создана",
  "Correction": "Исправление",
  "Record updated": "Запись обновлена",
  "All movements": "Все движения запасов",
  "Quarantined": "На карантине",
  "Not recorded": "Не зарегистрировано",
  "No matching records.": "Подходящих записей нет.",
  "Page": "Страница",
  "Evidence warnings": "Предупреждения о подтверждающих материалах",
  "Production": "Производство",
  "Create job": "Создать производственное задание",
  "Routes": "Технологические маршруты",
  "Search jobs": "Поиск производственных заданий",
  "Clear part filter": "Сбросить фильтр деталей",
  "No jobs found.": "Производственные задания не найдены.",
  "Select a job to review or record actual work.": "Выберите задание для просмотра или регистрации фактической работы.",
  "Change": "Изменить",
  "Select an exact definition revision.": "Выберите конкретную ревизию определения.",
  "Job identifier": "Идентификатор задания",
  "Route input": "Входной технологический маршрут",
  "Document inputs": "Входные документы",
  "Select route": "Выбрать маршрут",
  "Back": "Назад",
  "Create route": "Создать маршрут",
  "Create route revision": "Создать ревизию маршрута",
  "Choose another route": "Выбрать другой маршрут",
  "Inspection expected": "Предусмотрен контроль",
  "Route name": "Название маршрута",
  "Operation": "Операция",
  "Instructions": "Инструкции",
  "Move up": "Переместить вверх",
  "Move down": "Переместить вниз",
  "Remove operation": "Удалить операцию",
  "Add operation": "Добавить операцию",
  "Serials": "Серийные единицы",
  "ProductionOutputs": "Выпуск продукции",
  "Operations": "Операции",
  "Inspections": "Проверки",
  "Declarations": "Декларации",
  "Back to collection": "Назад к списку",
  "Recorded at": "Дата и время регистрации",
  "Created": "Создано",
  "Display columns": "Отображение столбцов",
  "Import records": "Импортировать записи",
  "Preview records": "Предпросмотр записей",
  "New preview": "Новый предпросмотр",
  "Apply valid rows": "Применить корректные строки",
  "Reload preview": "Перезагрузить предпросмотр",
  "Row {number}": "Строка {number}",
  "Applied": "Применено",
  "Apply row": "Применить строку",
  "Source name": "Название источника",
  "Record type": "Тип записи",
  "Download CSV template": "Скачать шаблон CSV",
  "CSV file": "Файл CSV",
  "Previous imports": "Предыдущие импорты",
  "Manual entry": "Ручной ввод",
  "Choose a CSV file.": "Выберите файл CSV.",
  "The CSV file exceeds the import size limit.": "Файл CSV превышает допустимый размер импорта.",
  "Serial number": "Серийный номер",
  "Output source reference": "Ссылка на источник выпуска",
  "Step": "Шаг",
  "Result": "Результат",
  "Actual result": "Фактический результат",
  "Kind": "Вид",
  "Value": "Значение",
  "Exact configuration": "Конкретная конфигурация",
  "Exact route revision": "Конкретная ревизия маршрута",
  "Material definition": "Определение материала",
  "Primary definition": "Основное определение",
  "Route revision": "Ревизия маршрута",
  "Record output": "Зарегистрировать выпуск",
  "Record operation": "Зарегистрировать операцию",
  "Record inspection": "Зарегистрировать проверку",
  "Record consumption or component": "Зарегистрировать расход или компонент",
  "Declare output": "Задекларировать выпуск",
  "Capture as-built": "Зафиксировать фактическую конфигурацию",
  "Unnamed record": "Запись без названия",
  "Serial": "Серийный номер",
  "None available": "Нет доступных",
  "The selected job was not found in an editable company.": "Выбранное задание не найдено в компании с доступом к редактированию.",
  "Offline job": "Автономное задание",
  "Download selected job": "Скачать выбранное задание",
  "Offline work": "Автономная работа",
  "Selected job and files saved for offline use.": "Выбранное задание и файлы сохранены для автономной работы.",
  "Download": "Скачать",
  "bytes": "байт",
  "Find material lots": "Найти партии материалов",
  "Find component parts": "Найти детали-компоненты",
  "Correct recorded work": "Исправить зарегистрированную работу",
  "Save correction": "Сохранить исправление",
  "Save offline": "Сохранить автономно",
  "Wait for evidence to finish saving.": "Дождитесь сохранения подтверждающих материалов.",
  "Choose an output with a recorded version.": "Выберите выпуск с зарегистрированной версией.",
  "Reconnect and load current records before saving a correction.": "Восстановите соединение и загрузите актуальные записи перед сохранением исправления.",
  "Confirm that this correction uses the current stock version.": "Подтвердите, что исправление использует актуальную версию запасов.",
  "The original recording is retained. Review current records before submitting a separate correction.": "Исходная запись сохраняется. Просмотрите актуальные записи перед отправкой отдельного исправления.",
  "Loading current records": "Загрузка актуальных записей",
  "Current stock": "Текущие запасы",
  "Completed": "Завершено",
  "Failed": "Неудача",
  "Skipped": "Пропущено",
  "InProgress": "В процессе",
  "Passed": "Пройдено",
  "Inconclusive": "Без однозначного вывода",
  "I reviewed the stock conflict and authorize this correction against current stock.": "Я проверил(-а) конфликт запасов и разрешаю это исправление с учётом текущих запасов.",
  "Quality": "Качество",
  "NotStarted": "Не начато",
  "Rejected": "Отклонено",
  "As-built": "Фактическая конфигурация",
  "Evidence file": "Файл подтверждающих материалов",
  "Saving evidence locally": "Локальное сохранение подтверждающих материалов",
  "The correction retains the original evidence attachments.": "Исправление сохраняет исходные вложения подтверждающих материалов.",
  "Reconnect to verify recorder access before continuing.": "Восстановите соединение, чтобы проверить доступ регистратора перед продолжением.",
  "Reconnect as the original offline recorder.": "Восстановите соединение как исходный автономный регистратор.",
  "Offline recording access was revoked. Recorded work is retained.": "Доступ к автономной регистрации отозван. Зарегистрированная работа сохранена.",
  "Reconnect": "Восстановить соединение",
  "Loading": "Загрузка",
  "No offline job is open. Download a selected production job while connected.": "Автономное задание не открыто. Скачайте выбранное производственное задание при наличии соединения.",
  "Selected job": "Выбранное задание",
  "Online": "В сети",
  "Offline": "Без сети",
  "Resume download": "Продолжить скачивание",
  "Synchronize": "Синхронизировать",
  "Close offline session": "Закрыть автономный сеанс",
  "Captured operations": "Зафиксированные операции",
  "No route captured": "Маршрут не зафиксирован",
  "Recorded inspections": "Зарегистрированные проверки",
  "Outputs": "Выпуск продукции",
  "No outputs recorded": "Выпуск продукции не зарегистрирован",
  "Downloaded files": "Скачанные файлы",
  "Material lots": "Партии материалов",
  "Record work": "Зарегистрировать работу",
  "Recorded commands": "Зарегистрированные действия",
  "No local commands recorded": "Локальные действия не зарегистрированы",
  "Retained original; correction recorded": "Оригинал сохранён; исправление зарегистрировано",
  "Retry unchanged": "Повторить без изменений",
  "Saved evidence": "Сохранённые подтверждающие материалы",
  "Close only after all recorded work and evidence are accepted. Local history remains available.": "Закрывайте только после принятия всей зарегистрированной работы и подтверждающих материалов. Локальная история остаётся доступной.",
  "Offline storage is unavailable in this browser.": "Автономное хранилище недоступно в этом браузере.",
  "The offline application could not be downloaded. Try again online.": "Не удалось скачать автономное приложение. Повторите попытку в сети.",
  "The offline application is not ready. Reload online and try again.": "Автономное приложение не готово. Перезагрузите страницу в сети и повторите попытку.",
  "An offline update is waiting. Close other registry tabs and reload online.": "Ожидает обновление автономного приложения. Закройте другие вкладки реестра и перезагрузите страницу в сети.",
  "Verified files": "Проверенные файлы",
  "Component part": "Деталь-компонент",
  "Component serials": "Серийные единицы компонентов",
  "Output": "Выпуск",
  "Reserved serial": "Зарезервированная серийная единица",
  "Output lot": "Партия выпущенной продукции",
  "Operation order": "Порядок операции",
  "Shared run": "Совместный производственный запуск",
  "Rework of": "Доработка операции",
  "Inspection": "Проверка",
  "Actual": "Фактическое значение",
  "Operation attempt": "Попытка выполнения операции",
  "Material lot": "Партия материала",
  "Component serial": "Серийная единица компонента",
  "Actual revision": "Фактическая ревизия",
  "Declaration": "Декларация",
  "Declared state": "Задекларированное состояние",
  "Amends snapshot": "Исправляет снимок",
  "Attach saved evidence": "Прикрепить сохранённые подтверждающие материалы",
  "preparing": "Подготовка",
  "downloading": "Скачивание",
  "ready": "Готово",
  "rejected": "Отклонено",
  "closed": "Закрыто",
  "pending": "Ожидает",
  "sending": "Отправка",
  "accepted": "Принято",
  "conflict": "Конфликт",
  "staged": "Сохранено локально",
  "uploading": "Передача",
  "verified": "Проверено",
  "attached": "Прикреплено",
  "Captured inputs": "Зафиксированные входные данные",
  "Captured route": "Зафиксированный маршрут",
  "Planned components": "Запланированные компоненты",
  "No planned components.": "Запланированных компонентов нет.",
  "No file evidence recorded.": "Файлы подтверждающих материалов не зарегистрированы.",
  "Evidence files": "Файлы подтверждающих материалов",
  "Actual outputs": "Фактический выпуск продукции",
  "No actual outputs recorded.": "Фактический выпуск продукции не зарегистрирован.",
  "Operations and inspections": "Операции и проверки",
  "Create shared run": "Создать совместный производственный запуск",
  "Record rework": "Зарегистрировать доработку",
  "No operations or inspections recorded.": "Операции и проверки не зарегистрированы.",
  "Actual components and lots": "Фактические компоненты и партии",
  "Record component or lot": "Зарегистрировать компонент или партию",
  "No actual components recorded.": "Фактические компоненты не зарегистрированы.",
  "Job documents": "Документы задания",
  "Whole job": "Всё задание",
  "Actual component": "Фактический компонент",
  "Unserialized output": "Несериализованная продукция",
  "Not declared": "Не задекларировано",
  "Declare production": "Задекларировать состояние производства",
  "Declare quality": "Задекларировать состояние качества",
  "Amend as-built": "Исправить фактическую конфигурацию",
  "Declaration history": "История деклараций",
  "As-built history": "История фактической конфигурации",
  "Snapshot": "Снимок состояния",
  "Choose a declaration.": "Выберите декларацию.",
  "As-built snapshot": "Снимок фактической конфигурации",
  "Actual output": "Фактический выпуск",
  "No serialized units found.": "Серийные единицы не найдены.",
  "Serialized output": "Сериализованная продукция",
  "Clear": "Очистить",
  "Choose a result.": "Выберите результат.",
  "Inspection name": "Название проверки",
  "Use shared run": "Использовать совместный запуск",
  "This job is not part of this shared run.": "Это задание не входит в этот совместный запуск.",
  "Choose another run": "Выбрать другой запуск",
  "Run identifier": "Идентификатор запуска",
  "Serialized unit": "Серийная единица",
  "Select the actual component or lot.": "Выберите фактический компонент или партию.",
  "Serial units": "Серийные единицы",
  "Allocate serials": "Выделить серийные номера",
  "Import serial labels": "Импортировать серийные обозначения",
  "Void": "Аннулировать",
  "Void serial": "Аннулировать серийный номер",
  "Reprint label": "Повторно напечатать этикетку",
  "Enter positive integer serial numbers.": "Введите серийные номера как положительные целые числа.",
  "Number of serials": "Количество серийных номеров",
  "Existing serial numbers": "Имеющиеся серийные номера",
  "Serial label": "Серийная этикетка",
  "Allow pop-ups to print this label.": "Разрешите всплывающие окна, чтобы напечатать эту этикетку.",
  "Print label": "Напечатать этикетку",
  "Lot {lot} uses draft material revision {revision}.": "Партия {lot} использует черновик ревизии материала {revision}.",
  "Consumed quarantined stock: {lot}.": "Израсходованы запасы на карантине: {lot}.",
  "Insufficient stock: {lot} at {location} ({disposition}); available {available}, recorded outgoing {outgoing}.": "Недостаточно запасов: {lot} в {location} ({disposition}); доступно {available}, зарегистрированный расход {outgoing}.",
  "syncing": "Синхронизация",
  "Supply the selected template's values.": "Укажите значения для выбранного шаблона.",
  "Manual intake contains an unknown column.": "Ручной ввод содержит неизвестный столбец.",
  "A manual value is missing or too long.": "Значение ручного ввода отсутствует или слишком длинное.",
  "Supply CSV text.": "Укажите текст CSV.",
  "Supply CSV text of at most 1 MiB.": "Укажите текст CSV размером до 1 МиБ.",
  "CSV text cannot contain null characters.": "Текст CSV не может содержать нулевые символы.",
  "CSV exceeds the 1 MiB UTF-8 limit.": "CSV превышает предел 1 МиБ в UTF-8.",
  "CSV must contain valid UTF-8 text.": "CSV должен содержать корректный текст UTF-8.",
  "The CSV header is missing.": "Заголовок CSV отсутствует.",
  "Every header must be unique.": "Каждый заголовок должен быть уникальным.",
  "The template requires this header, even when its values are optional.": "Шаблон требует этот заголовок, даже если значения необязательны.",
  "This column is not in the selected template.": "Этого столбца нет в выбранном шаблоне.",
  "CSV contains more than 500 data rows.": "CSV содержит более 500 строк данных.",
  "This row must have exactly the number of fields in the header.": "Количество полей этой строки должно точно соответствовать заголовку.",
  "Malformed CSV quoting or a field exceeds the 16,000-character limit. Correct the source and create a new preview.": "Некорректные кавычки CSV или поле превышает предел 16 000 символов. Исправьте источник и создайте новый предпросмотр.",
  "A source reference may occur only once in a preview.": "Ссылка на источник может встречаться только один раз в предпросмотре.",
  "Supply at least one data row.": "Укажите хотя бы одну строку данных.",
  "This preview uses an older intake contract. Create a new preview.": "Этот предпросмотр использует устаревшие правила импорта. Создайте новый предпросмотр.",
  "The selected row does not match this immutable preview.": "Выбранная строка не соответствует этому неизменяемому предпросмотру.",
  "Correct the CSV errors and create a new preview before applying this row.": "Исправьте ошибки CSV и создайте новый предпросмотр перед применением строки.",
  "This source row has already been applied with another payload or recorder. It cannot be overwritten.": "Эта исходная строка уже применена с другими данными или другим регистратором. Её нельзя перезаписать.",
  "This row no longer meets the intake contract. Create a new preview.": "Эта строка больше не соответствует правилам импорта. Создайте новый предпросмотр.",
  "Referenced data changed after preview. Review the current data and create a new preview; this row was not rebased.": "Связанные данные изменились после предпросмотра. Проверьте актуальные данные и создайте новый предпросмотр; эта строка не была автоматически согласована.",
  "No exact company reference matches this value.": "Этому значению не соответствует ни одна точная ссылка в компании.",
  "This reference is ambiguous; select an exact source reference.": "Эта ссылка неоднозначна; выберите точную ссылку на источник.",
  "This material identifier already exists; intake does not overwrite definitions.": "Этот идентификатор материала уже существует; импорт не перезаписывает определения.",
  "This lot identifier already exists; intake does not overwrite lots.": "Этот идентификатор партии уже существует; импорт не перезаписывает партии.",
  "Use the exact material revision unit.": "Используйте точную единицу ревизии материала.",
  "Use the exact authored lot unit; stock is not converted.": "Используйте точную заданную единицу партии; запасы не пересчитываются.",
  "The job must produce the exact selected part.": "Задание должно изготавливать именно выбранную деталь.",
  "This serial is already allocated or imported and cannot be reused.": "Этот серийный номер уже выделен или импортирован; повторное использование невозможно.",
  "A serialized output is exactly one ea.": "Сериализованная продукция имеет количество ровно 1 ea.",
  "A part job cannot declare a material lot output.": "Задание для детали не может декларировать выпуск партии материала.",
  "The operation must exist in the job's captured route.": "Операция должна существовать в зафиксированном маршруте задания.",
  "Select one actual output by its exact source reference.": "Выберите один фактический выпуск по точной ссылке на источник.",
  "Use at most {maximum} characters.": "Используйте не более {maximum} символов.",
  "A value is required.": "Требуется значение.",
  "Use a positive, unpadded integer.": "Используйте положительное целое число без ведущих нулей.",
  "Use a positive decimal quantity, without grouping, with at most six fractional and twelve integer digits.": "Укажите положительное десятичное количество без разделителей групп, не более шести дробных и двенадцати целых цифр.",
  "Use an actual UTC timestamp such as 2026-09-07T12:30:00Z.": "Укажите фактическую временную отметку UTC, например 2026-09-07T12:30:00Z.",
  "Choose Accepted or Quarantined.": "Выберите Accepted или Quarantined.",
  "Choose Completed, Failed, Skipped or InProgress.": "Выберите Completed, Failed, Skipped или InProgress.",
  "Choose Passed, Failed or Inconclusive.": "Выберите Passed, Failed или Inconclusive.",
  "An imported serial requires its complete part PIN.": "Импортируемый серийный номер требует полного PIN детали.",
  "Choose Production or Quality.": "Выберите Production или Quality.",
  "Choose a declaration value belonging to this kind.": "Выберите значение декларации, соответствующее этому виду.",
  "This intake preview was not found for this recorder and company.": "Этот предпросмотр импорта не найден для этого регистратора и компании.",
  "This preview row was not found.": "Эта строка предпросмотра не найдена.",
  "Choose a published intake template.": "Выберите опубликованный шаблон импорта.",
  "Use an actual UTC timestamp.": "Укажите фактическую временную отметку UTC.",
  "This material identifier already exists.": "Этот идентификатор материала уже существует.",
  "Released or used definitions stay unchanged. Create a new revision.": "Выпущенные или использованные определения остаются неизменными. Создайте новую ревизию.",
  "This material revision is already released.": "Эта ревизия материала уже выпущена.",
  "Use the exact material revision unit; stock is not converted.": "Используйте точную единицу ревизии материала; запасы не пересчитываются.",
  "This lot identifier already exists.": "Этот идентификатор партии уже существует.",
  "This lot changed. Reload its balances before recording stock.": "Эта партия изменилась. Загрузите актуальные остатки перед регистрацией запасов.",
  "Use the lot's exact authored unit; stock is not converted.": "Используйте точную заданную единицу партии; запасы не пересчитываются.",
  "Reverse the original movement before recording its replacement.": "Сторнируйте исходное движение запасов перед регистрацией замены.",
  "This movement already has a replacement.": "Это движение запасов уже имеет замену.",
  "This movement has already been corrected.": "Это движение запасов уже исправлено.",
  "Use an exact location without surrounding whitespace.": "Укажите точное место хранения без пробелов в начале и в конце.",
  "Split and merge require the same exact material revision.": "Разделение и объединение требуют одной и той же конкретной ревизии материала.",
  "Split and merge preserve disposition.": "Разделение и объединение сохраняют статус пригодности.",
  "Split and merge quantities must match exactly.": "Количества при разделении и объединении должны точно совпадать.",
  "This split or merge would create a cycle in the retained lot genealogy.": "Это разделение или объединение создало бы цикл в сохранённом происхождении партий.",
  "Quantity must be positive with at most six decimal places and twelve integer digits.": "Количество должно быть положительным, не более шести десятичных знаков и двенадцати целых цифр.",
  "Offline storage is unavailable. No local save was confirmed.": "Автономное хранилище недоступно. Локальное сохранение не подтверждено.",
  "Offline recording requires browser storage locking.": "Для автономной регистрации нужна блокировка хранилища браузера.",
  "Offline storage could not save the change. Keep the original work and retry.": "Автономное хранилище не сохранило изменение. Сохраните исходную работу и повторите попытку.",
  "Offline session not found.": "Автономный сеанс не найден.",
  "Resolve the saved change shown above before synchronizing offline work.": "Согласуйте показанное выше сохранённое изменение перед синхронизацией автономной работы.",
  "This offline session is not the active recorder.": "Этот автономный сеанс не является активным сеансом регистрации.",
  "Offline file storage is unavailable in this browser.": "Хранилище автономных файлов недоступно в этом браузере.",
  "Offline storage capacity cannot be checked.": "Невозможно проверить ёмкость автономного хранилища.",
  "Not enough browser storage for the selected offline files.": "В хранилище браузера недостаточно места для выбранных автономных файлов.",
  "Streaming downloads are unavailable.": "Потоковое скачивание недоступно.",
  "Choose one job and distinct offline files.": "Выберите одно задание и разные автономные файлы.",
  "Choose distinct material lots and component units for offline use.": "Выберите разные партии материалов и единицы компонентов для автономной работы.",
  "Reconnect, resolve the active offline work and explicitly close it before switching recorder or job.": "Восстановите соединение, согласуйте активную автономную работу и явно закройте её перед сменой регистратора или задания.",
  "Finish preparation or closing before resolving offline work.": "Завершите подготовку или закрытие перед согласованием автономной работы.",
  "Choose an unresolved conflicting or rejected command.": "Выберите неразрешённое конфликтующее или отклонённое действие.",
  "This offline session is not ready for new commands.": "Этот автономный сеанс не готов к новым действиям.",
  "Choose distinct evidence staged in this offline session.": "Выберите разные подтверждающие материалы, сохранённые в этом автономном сеансе.",
  "Only operation attempts and inspections support staged evidence.": "Только попытки выполнения операций и проверки поддерживают локально сохранённые подтверждающие материалы.",
  "Upload and verify the referenced offline evidence before synchronizing this command.": "Передайте и проверьте связанные автономные подтверждающие материалы перед синхронизацией этого действия.",
  "Select at most 1000 evidence files.": "Выберите не более 1000 файлов подтверждающих материалов.",
  "Finish preparation or closing before synchronizing.": "Завершите подготовку или закрытие перед синхронизацией.",
  "Finish preparation before synchronizing.": "Завершите подготовку перед синхронизацией.",
  "The offline command response did not confirm acceptance.": "Ответ на автономное действие не подтвердил его принятие.",
  "Upload and attach the staged offline evidence before closing. Local evidence is retained.": "Передайте и прикрепите сохранённые автономные подтверждающие материалы перед закрытием. Локальные материалы сохраняются.",
  "Resolve all pending, conflicting and rejected work before closing this offline session.": "Согласуйте всю ожидающую, конфликтующую и отклонённую работу перед закрытием этого автономного сеанса.",
  "The server session was closed elsewhere. Review the retained local work.": "Серверный сеанс закрыт в другом месте. Просмотрите сохранённую локальную работу.",
  "The server did not confirm closing this offline session.": "Сервер не подтвердил закрытие этого автономного сеанса.",
  "This file has not been downloaded and verified for offline use.": "Этот файл не скачан и не проверен для автономной работы.",
  "This offline session is not ready for new evidence.": "Этот автономный сеанс не готов к новым подтверждающим материалам.",
  "Choose a nonempty evidence file and filename.": "Выберите непустой файл подтверждающих материалов и укажите имя.",
  "This evidence has not been staged for offline use.": "Эти подтверждающие материалы не сохранены для автономной работы.",
  "Finish closing before updating evidence.": "Завершите закрытие перед обновлением подтверждающих материалов.",
  "Offline evidence changed. Read its current state before continuing.": "Автономные подтверждающие материалы изменились. Просмотрите их актуальное состояние перед продолжением.",
  "Resume the original evidence upload.": "Продолжите исходную передачу подтверждающих материалов.",
  "The verified server file does not match the staged evidence.": "Проверенный серверный файл не соответствует локально сохранённым подтверждающим материалам.",
  "This offline session belongs to another recorder.": "Этот автономный сеанс принадлежит другому регистратору.",
  "This offline session is closed. Its pending work cannot be submitted here.": "Этот автономный сеанс закрыт. Его ожидающую работу нельзя отправить здесь.",
  "This command identity is already bound to different work. Keep the original command and record any correction separately.": "Этот идентификатор действия уже связан с другой работой. Сохраните исходное действие и зарегистрируйте исправление отдельно.",
  "Use a serial reserved for this job before the session was prepared.": "Используйте серийный номер, зарезервированный для этого задания до подготовки сеанса.",
  "This component unit changed. Keep the recorded work and review the conflict.": "Эта единица компонента изменилась. Сохраните зарегистрированную работу и проверьте конфликт.",
  "This component revision changed. Keep the recorded work and review the conflict.": "Эта ревизия компонента изменилась. Сохраните зарегистрированную работу и проверьте конфликт.",
  "This material lot changed. Keep the recorded work and review the stock conflict before submitting a correction.": "Эта партия материала изменилась. Сохраните зарегистрированную работу и проверьте конфликт запасов перед отправкой исправления.",
  "This material revision changed. Keep the recorded work and review the conflict.": "Эта ревизия материала изменилась. Сохраните зарегистрированную работу и проверьте конфликт.",
  "The command payload does not match its record type. Keep the original pending work for review.": "Данные действия не соответствуют типу записи. Сохраните исходную ожидающую работу для проверки.",
  "Not started": "Не начато",
  "In progress": "В процессе",
  "Captured part revision was a draft.": "Зафиксированная ревизия детали была черновиком.",
  "Captured configuration was a draft.": "Зафиксированная конфигурация была черновиком.",
  "A captured component revision was a draft.": "Одна из зафиксированных ревизий компонентов была черновиком.",
  "Captured material revision was a draft.": "Зафиксированная ревизия материала была черновиком.",
  "Captured route revision was a draft.": "Зафиксированная ревизия маршрута была черновиком.",
  "A captured document revision was a draft.": "Одна из зафиксированных ревизий документов была черновиком.",
  "No route was captured.": "Маршрут не был зафиксирован.",
  "An operation has no completed attempt.": "Для одной из операций нет завершённой попытки.",
  "An expected inspection was not recorded.": "Предусмотренная проверка не зарегистрирована.",
  "The history includes failed operations.": "История содержит неудавшиеся операции.",
  "The history includes skipped operations.": "История содержит пропущенные операции.",
  "The history includes failed inspections.": "История содержит непройденные проверки.",
  "The history includes inconclusive inspections.": "История содержит проверки без однозначного вывода.",
  "No inspection evidence was recorded.": "Подтверждающие материалы проверок не зарегистрированы.",
  "Planned components have no recorded actuals.": "Для запланированных компонентов не зарегистрировано фактическое использование.",
  "A planned component quantity differs from the recorded actuals.": "Запланированное количество компонента отличается от зарегистрированного фактического.",
  "Quality has not been declared.": "Состояние качества не задекларировано.",
  "Production has not been declared.": "Состояние производства не задекларировано.",
  "Some actual components are recorded for the whole job, not an individual output.": "Некоторые фактические компоненты зарегистрированы для всего задания, а не отдельного выпуска.",
  "Some completed operations have no file evidence.": "Некоторые завершённые операции не имеют файловых подтверждений.",
  "An operation was recorded out of order.": "Операция зарегистрирована с нарушением последовательности.",
  "The serial label is void.": "Серийное обозначение аннулировано.",
  "Additional evidence warning recorded.": "Зарегистрировано дополнительное предупреждение о подтверждающих материалах.",
  "Document": "Документ",
  "Applies to output": "Относится к выпуску",
  "Earlier lot": "Предыдущая партия",
  "From lot": "Из партии",
  "Captured component evidence": "Зафиксированные подтверждающие материалы компонента",
  "Actual genealogy": "Фактическое происхождение",
  "Related operation": "Связанная операция",
  "Shared runs": "Совместные производственные запуски",
  "Add job to shared run": "Добавить задание в совместный запуск",
  "Actual component type": "Тип фактического компонента",
  "CSV": "CSV",
  "An accepted recording command must confirm this evidence attachment.": "Принятое действие регистрации должно подтвердить прикрепление этих подтверждающих материалов.",
  "Choose a downloaded material lot or component serial.": "Выберите загруженную партию материала или серийную единицу компонента.",
  "Choose a supported evidence update.": "Выберите поддерживаемое обновление подтверждающих материалов.",
  "Choose a supported offline command and an object payload.": "Выберите поддерживаемое автономное действие и данные в виде объекта.",
  "Choose the output receiving this component.": "Выберите выпуск продукции, в который входит этот компонент.",
  "Evidence file references must be a list of server file IDs.": "Ссылки на файлы подтверждающих материалов должны быть списком идентификаторов серверных файлов.",
  "Evidence upload failed.": "Не удалось передать подтверждающие материалы.",
  "Offline payloads must contain only JSON values.": "Данные автономных действий должны содержать только значения JSON.",
  "Online registry": "Реестр в сети",
  "Provide a corrected command payload object.": "Предоставьте исправленные данные действия в виде объекта.",
  "Provide the evidence upload error.": "Укажите ошибку передачи подтверждающих материалов.",
  "Reconnect to verify recorder access before synchronizing.": "Восстановите соединение, чтобы проверить доступ регистратора перед синхронизацией.",
  "The offline bundle is missing selected material lots or component units.": "В автономном наборе нет выбранных партий материалов или единиц компонентов.",
  "The offline file SHA-256 does not match its manifest.": "SHA-256 автономного файла не соответствует его описанию.",
  "The offline file URL does not match its session.": "URL автономного файла не соответствует его сеансу.",
  "The offline file length does not match its manifest.": "Размер автономного файла не соответствует его описанию.",
  "The offline file manifest is invalid.": "Описание автономного файла некорректно.",
  "The offline manifest does not match the selected files.": "Автономное описание не соответствует выбранным файлам.",
  "The offline session does not belong to this recorder and job.": "Автономный сеанс не принадлежит этому регистратору и заданию.",
  "The prepared offline bundle does not match this recorder and job.": "Подготовленный автономный набор не соответствует этому регистратору и заданию.",
  "The retained correction chain is incomplete.": "Сохранённая цепочка исправлений неполна.",
  "The retained correction chain is invalid.": "Сохранённая цепочка исправлений некорректна.",
  "The selected job changed. Open its download choices again.": "Выбранное задание изменилось. Откройте его параметры скачивания заново.",
  "The selected offline file could not be downloaded.": "Не удалось скачать выбранный автономный файл.",
  "The staged evidence failed SHA-256 verification.": "Локально подготовленные подтверждающие материалы не прошли проверку SHA-256.",
  "The stored offline evidence failed SHA-256 verification.": "Сохранённые автономные подтверждающие материалы не прошли проверку SHA-256.",
  "The stored offline file failed SHA-256 verification.": "Сохранённый автономный файл не прошёл проверку SHA-256.",
  "This offline session is closed.": "Этот автономный сеанс закрыт.",
  "This offline session is closed. Pending work is retained.": "Этот автономный сеанс закрыт. Ожидающая работа сохранена.",
  "Agent": "Агент",
  "Agents": "Агенты",
  "Member": "Участник",
  "Agent name": "Имя агента",
  "Agent reference": "Ссылка на агента",
  "Connected applications": "Подключённые приложения",
  "Connection address": "Адрес подключения",
  "MCP endpoint": "Адрес MCP",
  "New agent": "Новый агент",
  "Create agent": "Создать агента",
  "Manage": "Управлять",
  "Review transfer": "Рассмотреть передачу",
  "Management transfer awaiting your response": "Передача управления ожидает вашего ответа",
  "Management transfer pending": "Ожидается передача управления",
  "No connected applications.": "Нет подключённых приложений.",
  "No agents yet.": "Агентов пока нет.",
  "Last used {date}": "Последнее использование: {date}",
  "Disconnect": "Отключить",
  "Disconnect {name}?": "Отключить {name}?",
  "This application will lose access through this connection.": "Это приложение потеряет доступ через это подключение.",
  "Manage {name}?": "Управлять {name}?",
  "Accept management": "Принять управление",
  "Decline transfer": "Отклонить передачу",
  "Accepting management revokes the existing credentials. Create new credentials before running this agent again.": "Принятие управления отзывает действующие учётные данные. Создайте новые перед следующим запуском агента.",
  "Disabled": "Отключён",
  "Enable agent": "Включить агента",
  "Disable agent": "Отключить агента",
  "Enable {name}?": "Включить {name}?",
  "Disable {name}?": "Отключить {name}?",
  "Rename": "Переименовать",
  "Rename agent": "Переименовать агента",
  "Transfer management": "Передать управление",
  "Cancel transfer": "Отменить передачу",
  "Request transfer": "Запросить передачу",
  "New manager’s Google account email": "Электронная почта Google нового управляющего",
  "Share agent reference": "Поделиться ссылкой на агента",
  "Company access": "Доступ к компаниям",
  "No company access. A company owner can add this agent in Members.": "Нет доступа к компаниям. Владелец компании может добавить агента в разделе «Участники».",
  "Credentials": "Учётные данные",
  "New credential": "Новые учётные данные",
  "Create credential": "Создать учётные данные",
  "Credential name": "Название учётных данных",
  "No credentials yet.": "Учётных данных пока нет.",
  "Rotate secret": "Заменить секрет",
  "Rotate {name}?": "Заменить секрет {name}?",
  "Revoke {name}?": "Отозвать {name}?",
  "Create new credentials after enabling this agent.": "После включения агента создайте новые учётные данные.",
  "This revokes its credentials and stops access in every company.": "Это отзывает учётные данные и прекращает доступ ко всем компаниям.",
  "Existing access tokens issued with this credential will stop working.": "Действующие токены доступа, выданные с этими учётными данными, перестанут работать.",
  "Connection credentials": "Учётные данные подключения",
  "Client ID": "Идентификатор клиента",
  "Client secret": "Секрет клиента",
  "The secret is shown only once. Save it in your agent’s credential storage.": "Секрет показывается только один раз. Сохраните его в хранилище учётных данных агента.",
  "The credential was created, but its secret cannot be shown again. Rotate the secret to replace it.": "Учётные данные созданы, но секрет нельзя показать снова. Замените секрет.",
  "Copy {value}": "Копировать {value}",
  "Copy was unavailable. Select the value and copy it manually.": "Копирование недоступно. Выделите значение и скопируйте его вручную.",
  "Add agent": "Добавить агента",
  "Choose a valid agent reference.": "Укажите действительную ссылку на агента.",
  "Managed by {name}": "Управляет {name}",
  "Connect application": "Подключить приложение",
  "Allow connection": "Разрешить подключение",
  "Redirect address": "Адрес перенаправления",
  "This application can use your current company roles. Access follows changes to your memberships.": "Это приложение может действовать согласно вашим текущим ролям в компаниях. Доступ меняется вместе с вашим членством.",
  "Agent created": "Агент создан",
  "Agent updated": "Агент обновлён",
  "Agent disabled": "Агент отключён",
  "Credential created": "Учётные данные созданы",
  "Credential rotated": "Учётные данные заменены",
  "Credential revoked": "Учётные данные отозваны",
  "Transfer requested": "Передача запрошена",
  "Transfer cancelled": "Передача отменена",
  "Transfer accepted": "Передача принята",
  "Active agent not found.": "Активный агент не найден.",
  "Agent not found.": "Агент не найден.",
  "Managed agent not found.": "Управляемый агент не найден.",
  "Credential not found.": "Учётные данные не найдены.",
  "Connection not found.": "Подключение не найдено.",
  "Transfer not found.": "Передача не найдена.",
  "This transfer has expired.": "Срок передачи истёк.",
  "Choose another manager.": "Выберите другого управляющего.",
  "The new manager must sign in to the registry first.": "Новый управляющий должен сначала войти в реестр.",
  "A human account manages agent credentials.": "Учётными данными агента управляет человек.",
  "Enable the agent before creating credentials.": "Включите агента перед созданием учётных данных.",
  "Create a new credential after revocation.": "После отзыва создайте новые учётные данные.",
  "This agent is already a member.": "Этот агент уже является участником.",
  "Another owner must accept membership before disabling the last owner.": "Другой владелец должен принять приглашение перед отключением последнего владельца.",
  "Application not found.": "Приложение не найдено.",
  "Users": "Users",
  "Global directory": "Global directory",
  "Search people by name or email": "Search people by name or email",
  "Search users": "Search users",
  "All roles": "All roles",
  "All users": "All users",
  "Administrators": "Administrators",
  "Name / Email": "Name / Email",
  "Web-app role": "Web-app role",
  "Direct companies": "Direct companies",
  "Effective access": "Effective access",
  "Administrator": "Administrator",
  "User": "User",
  "No company access": "No company access",
  "{value0} companies": "{value0} companies",
  "{value0} of {value1} users": "{value0} of {value1} users",
  "No users match these filters.": "No users match these filters.",
  "Grant company access": "Grant company access",
  "No direct company access.": "No direct company access.",
  "Administrator · all companies": "Administrator · all companies",
  "Remove administrator": "Remove administrator",
  "Make administrator": "Make administrator",
  "Remove administrator?": "Remove administrator?",
  "Make administrator?": "Make administrator?",
  "This removes inherited access to every company. Direct memberships remain.": "This removes inherited access to every company. Direct memberships remain.",
  "This gives the user access to every company and the ability to manage users.": "This gives the user access to every company and the ability to manage users.",
  "Remove access?": "Remove access?",
  "Remove access to {value0}": "Remove access to {value0}",
  "Remove direct access to {value0}.": "Remove direct access to {value0}.",
  "Role for {value0}": "Role for {value0}",
  "Company role": "Company role",
  "Grant access": "Grant access",
  "Only web-app administrators can manage the user directory.": "Only web-app administrators can manage the user directory.",
  "Common parts": "Общие детали",
  "Common": "Общая",
  "Add part to {value0}": "Добавить деталь в {value0}",
  "Assembly actions": "Действия сборки",
  "Create symmetry": "Создать симметрию",
  "Variant created.": "Вариант создан.",
  "Symmetry family updated.": "Семейство симметрии обновлено.",
  "Document categories": "Категории документов",
  "Document category": "Категория документа",
  "Add category": "Добавить категорию",
  "Edit category": "Изменить категорию",
  "Edit category {name}": "Изменить категорию {name}",
  "Category added.": "Категория добавлена.",
  "Category saved.": "Категория сохранена.",
  "Category name": "Название категории",
  "Category code": "Код категории",
  "App default": "Стандартная",
  "Archived": "Архивная",
  "Show archived categories": "Показать архивные категории",
  "No categories available.": "Нет доступных категорий.",
  "Reload": "Обновить",
  "Only company owners and editors can manage document categories.": "Только владельцы и редакторы компании могут управлять категориями документов.",
  "Existing categories share these codes: {codes}. Their records remain separate.": "Существующие категории имеют одинаковые коды: {codes}. Их записи остаются раздельными.",
  "Upload document": "Загрузить документ",
  "Apply to selected": "Применить к выбранным",
  "Back to files": "Назад к файлам",
  "Browser storage is unavailable. Keep this window open to retain your edits.": "Хранилище браузера недоступно. Не закрывайте это окно, чтобы сохранить изменения.",
  "Category for {name}": "Категория для {name}",
  "Check the saved upload change before continuing.": "Проверьте сохранённое изменение загрузки, прежде чем продолжить.",
  "Choose a matching document": "Выберите соответствующий документ",
  "Choose which document should receive this revision.": "Выберите документ, к которому следует добавить эту ревизию.",
  "Create a separate document": "Создать отдельный документ",
  "Detected from": "Определено по",
  "Drag and drop files here": "Перетащите файлы сюда",
  "Edit selected files": "Изменить выбранные файлы",
  "Edit {count} selected files": "Изменить выбранные файлы: {count}",
  "File details and applicability": "Сведения о файле и применимость",
  "File preview": "Предпросмотр файла",
  "File size": "Размер файла",
  "Filename": "Имя файла",
  "Keep current": "Оставить текущие",
  "Matching document for {name}": "Соответствующий документ для {name}",
  "New document": "Новый документ",
  "New revision of {identifier}": "Новая ревизия {identifier}",
  "Next file": "Следующий файл",
  "Not specified": "Не указано",
  "Preview unavailable for this file format.": "Предпросмотр этого формата файла недоступен.",
  "Preview {name}": "Предпросмотр {name}",
  "Previous file": "Предыдущий файл",
  "Reading file details…": "Чтение сведений о файлах…",
  "Recover saved upload": "Восстановить сохранённую загрузку",
  "Select a file to preview.": "Выберите файл для предпросмотра.",
  "Select all files": "Выбрать все файлы",
  "Select files": "Выбрать файлы",
  "Select files to upload.": "Выберите файлы для загрузки.",
  "Select the original file to preview or resume.": "Выберите исходный файл для просмотра или продолжения загрузки.",
  "Select the original file to resume.": "Выберите исходный файл, чтобы продолжить загрузку.",
  "Select {name}": "Выбрать {name}",
  "Title for {name}": "Название для {name}",
  "Title pattern": "Шаблон названия",
  "Uploading {name}": "Загрузка {name}",
  "Use {name} for the current title and {n} for a sequence number.": "Используйте {name} для текущего названия, а {n} — для порядкового номера.",
  "{count} files": "Файлов: {count}",
  "{count} selected": "Выбрано: {count}",
  "{done} of {total} uploaded": "Загружено {done} из {total}",
  "Add files": "Добавить файлы",
  "Retry unfinished uploads": "Повторить незавершённые загрузки",
  "Drawing": "Чертёж",
  "Assembly drawing": "Сборочный чертёж",
  "Production drawing": "Производственный чертёж",
  "Bill of materials": "Ведомость материалов",
  "Work instruction": "Рабочая инструкция",
  "Schematic": "Принципиальная схема",
  "Wiring diagram": "Схема соединений",
  "Layout": "Компоновка",
  "3D model": "3D-модель",
  "Test procedure": "Методика испытаний",
  "Test report": "Протокол испытаний",
  "Inspection plan": "План контроля",
  "Inspection report": "Отчёт о контроле",
  "Certificate": "Сертификат",
  "Material datasheet": "Технический паспорт материала",
  "Calculation": "Расчёт",
  "Requirements": "Требования",
  "Design report": "Проектный отчёт",
  "Assembly instruction": "Инструкция по сборке",
  "Manufacturing process": "Технологический процесс",
  "Quality plan": "План качества",
  "Change notice": "Извещение об изменении",
  "Manual": "Руководство",
  "Upload": "Загрузить",
  "Ready": "Готово",
  "Needs attention": "Требует внимания",
  "Retained": "Сохранённая",
  "manual": "Изменено вручную",
  "filename": "Имя файла",
  "embedded metadata": "Встроенные метаданные",
  "filename fallback": "Имя файла; общая категория",
  "Embedded metadata": "Встроенные метаданные",
  "Embedded title": "Встроенное название",
  "File selection key": "Ключ выбора файла",
  "Media type": "Тип содержимого",
  "Document category added": "Категория документов добавлена",
  "Document category archived": "Категория документов архивирована",
  "Document category updated": "Категория документов обновлена",
  "Document upload batch created": "Создан пакет загрузки документов",
  "Document draft retained": "Черновик документа сохранён",
  "Document upload saved": "Загруженный документ сохранён",
  "Add a Company or Project category.": "Добавьте категорию компании или проекта.",
  "Choose a category available in this document context.": "Выберите категорию, доступную для этого документа.",
  "Choose a project only for a Project category.": "Выбирайте проект только для категории проекта.",
  "Choose the project that owns this document context.": "Выберите проект, к которому относится этот документ.",
  "This category code already exists in this scope or an inherited scope. Choose another code.": "Этот код категории уже существует здесь или в унаследованных категориях. Выберите другой код.",
  "This category is archived. Choose an available category.": "Эта категория архивирована. Выберите доступную категорию.",
  "This editable category was not found in this company.": "В этой компании не найдена такая категория для редактирования.",
  "Use an uppercase alphanumeric category code starting with a letter.": "Используйте код категории из заглавных латинских букв и цифр, начинающийся с буквы.",
  "A saved document file cannot be removed from its upload batch.": "Сохранённый файл документа нельзя удалить из пакета загрузки.",
  "A selected file key is already in this batch.": "Ключ выбранного файла уже есть в этом пакете.",
  "Choose a document category.": "Выберите категорию документа.",
  "Choose a row in this upload batch.": "Выберите строку в этом пакете загрузки.",
  "Choose an available document category.": "Выберите доступную категорию документа.",
  "Choose between 1 and 1000 files.": "Выберите от 1 до 1000 файлов.",
  "Choose distinct upload rows to edit.": "Выберите разные строки загрузки для редактирования.",
  "Choose either an existing document or a new document.": "Выберите существующий или новый документ.",
  "Resume this batch with the recorder who started it.": "Продолжите этот пакет под учётной записью, которая его начала.",
  "Several documents match this file. Choose the intended document or create a separate document.": "Этому файлу соответствует несколько документов. Выберите нужный или создайте отдельный документ.",
  "The selected document no longer matches this owner, category and title. Review the row again.": "Выбранный документ больше не соответствует этому владельцу, категории и названию. Проверьте строку ещё раз.",
  "This document has an unfinished upload. Finish or cancel it before retrying this row.": "У этого документа есть незавершённая загрузка. Завершите или отмените её, прежде чем повторить эту строку.",
  "This upload batch was cancelled.": "Этот пакет загрузки отменён.",
  "This upload row is already saved or cancelled.": "Эта строка загрузки уже сохранена или отменена.",
  "Upload and verify this file before saving the document.": "Загрузите и проверьте этот файл перед сохранением документа.",
  "Select the original file for this upload row.": "Выберите исходный файл для этой строки загрузки.",
  "This row already has a different upload. Cancel that upload before replacing it.": "У этой строки уже есть другая загрузка. Отмените её перед заменой.",
  "Preview will be available after upload.": "Предварительный просмотр станет доступен после загрузки.",
  "existing document": "Существующий документ",
  "file extension": "Расширение файла",
  "More": "Ещё",
  "Edit quantity for {value0}": "Изменить количество для {value0}",
  "This structure cannot contain itself.": "Структура не может содержать саму себя."
}
